import { C as yr, D as Tr, E as br, S as xr, _ as wr, c as Er, f as Cr, g as kr, s as Ar, t as Pr, u as Mr, w as Ir, x as Or, y as Rr } from "./layout-BD1t4ofR.js";
import { a as Dr, i as Fr, t as Lr } from "./common-Cd7R8f1s.js";
import { n as u, t as q } from "./Logger-CmiOOsKC.js";
import { a as $r, r as Hr } from "./tracebehavior-5_qSKjs6.js";
import { $ as Ur, A as lt, C as Vr, J as Xr, N as ht, Q as Wr, S as jr, St as qr, T as Yr, X as Zr, Y as Kr, Z as Qr, _t as Jr, at as en, b as tn, bt as rn, ct as nn, dt as an, et as sn, ft as on, g as cn, gt as ln, ht as hn, it as un, j as ut, lt as gn, m as dn, mt as mn, nt as fn, ot as pn, p as _n, pt as Sn, q as vn, rt as yn, st as Tn, t as bn, tt as xn, u as Be, ut as wn, vt as En, w as Cn, wt as kn, x as An, xt as Pn, y as Mn, yt as In } from "./SceneCreation-DVCYLXYF.js";
import { a as Rn, n as Bn, r as Dn, t as Fn } from "./AnimationUtils-Dau2PA8x.js";
import { n as zn, t as Nn } from "./animationsequence-C8TMiBUE.js";
import { s as Hn, t as Gn } from "./playable-tG_Q2o5X.js";
import { t as Vn } from "./audioclip-D2YGwkWS.js";
import { A as gt, C as dt, D as mt, E as ft, F as pt, H as Wn, I as _t, J as jn, M as St, N as vt, O as yt, P as Tt, Q as qn, R as Yn, S as bt, T as xt, V as ve, X as Zn, Y as Kn, _ as wt, a as Qn, b as Et, c as Ct, d as kt, f as At, g as Pt, h as Mt, i as Jn, j as It, k as Ot, l as Rt, m as Bt, n as ea, o as ta, p as Dt, q as ia, r as ra, s as na, t as aa, u as Ft, v as Lt, w as zt, x as Nt, y as $t, z as Ht } from "./ScriptRegistry-C3vqndus.js";
import { t as la } from "./boxcollider-DfK5pGI3.js";
import { A as ua, C as ga, D as da, E as ma, O as fa, S as pa, T as _a, _ as Sa, a as va, b as ya, c as Gt, d as Ta, f as ba, g as xa, h as wa, i as Ea, j as Ca, k as ka, l as Aa, m as Pa, n as Ma, o as Ia, p as Oa, r as Ra, s as Ba, u as Da, w as Fa, x as La, y as za } from "./behaviors-0Dz87Ufy.js";
import { c as $a, d as Ha, f as Ga, l as Ua, s as Va, t as Xa, u as Wa } from "./properties-C_pgb9zu.js";
import { C as qa, T as Ya, _ as Za, a as Ka, c as Qa, d as Ja, f as es, h as ts, i as is, l as rs, n as ns, o as as, p as ss, r as os, s as cs, t as ls, u as hs, w as us, x as gs } from "./AssetTypes-DUDo9FdH.js";
import { t as ye } from "./Utility-CviQuQTA.js";
import { c as fs, l as ps, n as _s, r as Ss, s as vs, t as ys } from "./morphstretch-YfBvUhFE.js";
import { t as bs } from "./imageanchor-DusNzbVp.js";
import { a as ws, c as Es, d as Cs, f as ks, g as As, h as Ps, i as Ms, l as Is, m as Os, o as Rs, p as Bs, r as Ds, s as Fs, t as Ls, u as zs, x as Ns } from "./text-CeJQaWao.js";
import { c as Ut, l as Vt, n as Xt, o as Hs, p as Wt, r as De, t as Gs } from "./TraceScene-CTdK35pV.js";
import { t as Vs } from "./configdata-C580O024.js";
import { r as Y, t as jt } from "./abort-qw0xAdg5.js";
import { a as qt, d as js, l as qs, o as Yt, t as Zt, u as Ys } from "./GltfSceneLoaderPlugin-g47wYMf3.js";
import { s as Ks, t as Kt } from "./SceneExporter-BNrB8cfd.js";
import { s as Qt } from "./documentRoot-BRVSd6Oa.js";
import { a as eo, c as to, d as io, i as ro, l as no, n as ao, o as Jt, r as ei, s as so, t as oo, u as co } from "./ImageMarkerLoader-aTenj78C.js";
import { a as ti, n as Ee, t as ii } from "./localizerTracking-DNXVMp7I.js";
import "./exports/types.js";
import { n as go, t as mo } from "./MotionExport-B3J7AVJC.js";
import "./exports/animation.js";
import { t as _o } from "./graphOrdering-DH1LjtCN.js";
import { t as vo } from "./scene-h-1V-YHp.js";
import { Quaternion as me, Vector3 as O } from "@babylonjs/core/Maths/math.vector.js";
import { RegisterSceneLoaderPlugin as Z } from "@babylonjs/core/Loading/sceneLoader.js";
import { Mesh as Fe } from "@babylonjs/core/Meshes/mesh.js";
import { MeshBuilder as se } from "@babylonjs/core/Meshes/meshBuilder.js";
import "@babylonjs/core/Meshes/Builders/planeBuilder.js";
import { PointerEventTypes as U, PointerInfo as Qe } from "@babylonjs/core/Events/pointerEvents.js";
import { AdvancedDynamicTexture as Ce } from "@babylonjs/gui/2D/advancedDynamicTexture.js";
import { Ellipse as ri } from "@babylonjs/gui/2D/controls/ellipse.js";
import { TextBlock as Le } from "@babylonjs/gui/2D/controls/textBlock.js";
import { Control as oe } from "@babylonjs/gui/2D/controls/control.js";
import { Color3 as ni, Color4 as Je } from "@babylonjs/core/Maths/math.color.js";
import { AbstractMesh as ai } from "@babylonjs/core/Meshes/abstractMesh.js";
import { TransformNode as ze } from "@babylonjs/core/Meshes/transformNode.js";
import "@babylonjs/core/Collisions/pickingInfo.js";
import { Scene as si } from "@babylonjs/core/scene.js";
import { Texture as Ne } from "@babylonjs/core/Materials/Textures/texture.js";
import { Constants as $e } from "@babylonjs/core/Engines/constants.js";
import { VertexBuffer as He } from "@babylonjs/core/Buffers/buffer.js";
import { addToBlockFactory as b } from "@babylonjs/core/FlowGraph/Blocks/flowGraphBlockFactory.js";
import { addNewInteractivityFlowGraphMapping as oi } from "@babylonjs/loaders/glTF/2.0/Extensions/KHR_interactivity/declarationMapper.js";
import { AssetContainer as ci } from "@babylonjs/core/assetContainer.js";
import { ShaderMaterial as Ge } from "@babylonjs/core/Materials/shaderMaterial.js";
import { Effect as et } from "@babylonjs/core/Materials/effect.js";
import { Engine as li } from "@babylonjs/core/Engines/engine.js";
import "@babylonjs/core/Culling/ray.js";
import "@babylonjs/core/Collisions/collisionCoordinator.js";
import { SelectionOutlineLayer as hi } from "@babylonjs/core/Layers/selectionOutlineLayer.js";
import "@babylonjs/core/Layers/effectLayerSceneComponent.js";
import "@babylonjs/core/Rendering/depthRendererSceneComponent.js";
import { WebXRExperienceHelper as ui } from "@babylonjs/core/XR/webXRExperienceHelper.js";
import { WebXRState as H } from "@babylonjs/core/XR/webXRTypes.js";
import { WebXRDomOverlay as gi } from "@babylonjs/core/XR/features/WebXRDOMOverlay.js";
import { WebXRInput as di } from "@babylonjs/core/XR/webXRInput.js";
import { WebXRControllerPointerSelection as mi } from "@babylonjs/core/XR/features/WebXRControllerPointerSelection.js";
import "@babylonjs/core/XR/features/WebXRImageTracking.js";
import { WebXRFeatureName as Te } from "@babylonjs/core/XR/webXRFeaturesManager.js";
import "@babylonjs/loaders/SPLAT/index.js";
import { GaussianSplattingMesh as fi } from "@babylonjs/core/Meshes/GaussianSplatting/gaussianSplattingMesh.js";
import { ParseSpz as pi } from "@babylonjs/loaders/SPLAT/spz.js";
var d = "trace";
function x(t, e) {
  const i = ht(t), r = i ? ut(i) : void 0;
  oi(t, lt, r ? {
    ...e,
    declarationSchema: r
  } : e);
}
var Ue = !1;
function _i() {
  Ue || (Ue = !0, b(d, "PointerSetBlock", async () => Ft), b(d, "PointerGetBlock", async () => Rt), b(d, "PointerInterpolateBlock", async () => Ct), b(d, "TraceSetActiveBlock", async () => pt), b(d, "TraceGetActiveBlock", async () => Ht), b(d, "TraceGetChildCountBlock", async () => bt), b(d, "TraceSetActiveChildBlock", async () => dt), b(d, "TracePlayAnimationBlock", async () => Tt), b(d, "TracePlayExternalBlock", async () => vt), b(d, "TracePlayVideoBlock", async () => St), b(d, "TracePlayMediaBlock", async () => yt), b(d, "TracePauseMediaBlock", async () => mt), b(d, "TraceStopMediaBlock", async () => It), b(d, "TraceSeekMediaBlock", async () => Ot), b(d, "TraceSetMediaVolumeBlock", async () => gt), b(d, "TraceIsMediaPlayingBlock", async () => ft), b(d, "TraceGetMediaVolumeBlock", async () => xt), b(d, "TraceSetBehaviorEnabledBlock", async () => _t), b(d, "TraceNavigateBlock", async () => zt), b(d, "TraceGetPropertyBlock", async () => Nt), b(d, "TraceSetPropertyBlock", async () => Et), b(d, "TraceTimeBlock", async () => $t), b(d, "TraceSetStateBlock", async () => Lt), b(d, "TraceGetStateBlock", async () => wt), b(d, "TraceOnStateChangeBlock", async () => Pt), b(d, "TraceProximityEventBlock", async () => Mt), b(d, "TracePagesNextBlock", async () => Dt), b(d, "TracePagesPrevBlock", async () => Bt), b(d, "TracePagesGetActiveIndexBlock", async () => kt), b(d, "TracePagesGetPageCountBlock", async () => At), x("pointerSet", {
    blocks: [`${d}/PointerSetBlock`],
    configuration: {
      target: { name: "target" },
      property: { name: "property" }
    },
    inputs: {
      values: { value: { name: "value" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("pointerInterpolate", {
    blocks: [`${d}/PointerInterpolateBlock`],
    configuration: {
      target: { name: "target" },
      property: { name: "property" }
    },
    inputs: {
      values: {
        value: { name: "value" },
        duration: { name: "duration" },
        p1: { name: "p1" },
        p2: { name: "p2" }
      },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: {
      out: { name: "out" },
      done: { name: "done" },
      err: { name: "err" }
    } }
  }), x("pointerGet", {
    blocks: [`${d}/PointerGetBlock`],
    configuration: {
      target: { name: "target" },
      property: { name: "property" }
    },
    outputs: { values: { value: { name: "value" } } }
  }), x("setActive", {
    blocks: [`${d}/TraceSetActiveBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: { state: { name: "state" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("setBehaviorEnabled", {
    blocks: [`${d}/TraceSetBehaviorEnabledBlock`],
    configuration: {
      target: { name: "target" },
      behavior: { name: "behavior" }
    },
    inputs: {
      values: { enabled: { name: "enabled" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("getActive", {
    blocks: [`${d}/TraceGetActiveBlock`],
    configuration: { target: { name: "target" } },
    outputs: { values: { value: { name: "value" } } }
  }), x("getChildCount", {
    blocks: [`${d}/TraceGetChildCountBlock`],
    configuration: { target: { name: "target" } },
    outputs: { values: { value: { name: "value" } } }
  }), x("setActiveChild", {
    blocks: [`${d}/TraceSetActiveChildBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: { index: { name: "index" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("playAnimation", {
    blocks: [`${d}/TracePlayAnimationBlock`],
    configuration: {
      target: { name: "target" },
      clip: { name: "clip" }
    },
    inputs: {
      values: {
        speed: { name: "speed" },
        loop: { name: "loop" }
      },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: {
      out: { name: "out" },
      done: { name: "done" }
    } }
  }), x("playAnimationExternal", {
    blocks: [`${d}/TracePlayExternalBlock`],
    configuration: {
      target: { name: "target" },
      src: { name: "src" },
      clip: { name: "clip" }
    },
    inputs: {
      values: {
        speed: { name: "speed" },
        loop: { name: "loop" }
      },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: {
      out: { name: "out" },
      started: { name: "started" },
      done: { name: "done" }
    } }
  }), x("playVideo", {
    blocks: [`${d}/TracePlayVideoBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: {
        play: { name: "play" },
        volume: { name: "volume" },
        seek: { name: "seek" }
      },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("playMedia", {
    blocks: [`${d}/TracePlayMediaBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: {
        src: { name: "src" },
        volume: { name: "volume" },
        seek: { name: "seek" }
      },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("pauseMedia", {
    blocks: [`${d}/TracePauseMediaBlock`],
    configuration: { target: { name: "target" } },
    inputs: { flows: { in: { name: "in" } } },
    outputs: { flows: { out: { name: "out" } } }
  }), x("stopMedia", {
    blocks: [`${d}/TraceStopMediaBlock`],
    configuration: { target: { name: "target" } },
    inputs: { flows: { in: { name: "in" } } },
    outputs: { flows: { out: { name: "out" } } }
  }), x("seekMedia", {
    blocks: [`${d}/TraceSeekMediaBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: { time: { name: "time" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("setMediaVolume", {
    blocks: [`${d}/TraceSetMediaVolumeBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: { volume: { name: "volume" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("isMediaPlaying", {
    blocks: [`${d}/TraceIsMediaPlayingBlock`],
    configuration: { target: { name: "target" } },
    outputs: { values: { value: { name: "value" } } }
  }), x("getMediaVolume", {
    blocks: [`${d}/TraceGetMediaVolumeBlock`],
    configuration: { target: { name: "target" } },
    outputs: { values: { value: { name: "value" } } }
  }), x("navigate", {
    blocks: [`${d}/TraceNavigateBlock`],
    inputs: {
      values: { url: { name: "url" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("getProperty", {
    blocks: [`${d}/TraceGetPropertyBlock`],
    configuration: {
      target: { name: "target" },
      property: { name: "property" }
    },
    outputs: { values: { value: { name: "value" } } }
  }), x("time", {
    blocks: [`${d}/TraceTimeBlock`],
    outputs: { values: { elapsed: { name: "elapsed" } } }
  }), x("setProperty", {
    blocks: [`${d}/TraceSetPropertyBlock`],
    configuration: {
      target: { name: "target" },
      property: { name: "property" },
      transition: { name: "transition" }
    },
    inputs: {
      values: { value: { name: "value" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("setState", {
    blocks: [`${d}/TraceSetStateBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: { state: { name: "state" } },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("getState", {
    blocks: [`${d}/TraceGetStateBlock`],
    configuration: { target: { name: "target" } },
    outputs: { values: { state: { name: "state" } } }
  }), x("onStateChange", {
    blocks: [`${d}/TraceOnStateChangeBlock`],
    configuration: { target: { name: "target" } },
    outputs: {
      values: {
        prevState: { name: "prevState" },
        newState: { name: "newState" }
      },
      flows: { out: { name: "out" } }
    }
  }), x("pagesNext", {
    blocks: [`${d}/TracePagesNextBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: {
        wrap: { name: "wrap" },
        animate: { name: "animate" }
      },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("pagesPrev", {
    blocks: [`${d}/TracePagesPrevBlock`],
    configuration: { target: { name: "target" } },
    inputs: {
      values: {
        wrap: { name: "wrap" },
        animate: { name: "animate" }
      },
      flows: { in: { name: "in" } }
    },
    outputs: { flows: { out: { name: "out" } } }
  }), x("pagesGetActiveIndex", {
    blocks: [`${d}/TracePagesGetActiveIndexBlock`],
    configuration: { target: { name: "target" } },
    outputs: { values: { value: { name: "value" } } }
  }), x("pagesGetPageCount", {
    blocks: [`${d}/TracePagesGetPageCountBlock`],
    configuration: { target: { name: "target" } },
    outputs: { values: { value: { name: "value" } } }
  }), x("onProximity", {
    blocks: [`${d}/TraceProximityEventBlock`],
    configuration: { target: { name: "target" } },
    inputs: { values: { threshold: { name: "threshold" } } },
    outputs: {
      values: { distance: { name: "distance" } },
      flows: {
        enter: { name: "enter" },
        exit: { name: "exit" }
      }
    }
  }));
}
var be = class {
  loadingUIBackgroundColor = "transparent";
  loadingContainer;
  loadingBar;
  loadingText;
  parentContainer;
  constructor(t, e) {
    this.loadingUIText = t, this.parentContainer = e || document.body, this.loadingContainer = document.createElement("div"), this.loadingContainer.style.cssText = `position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:${this.loadingUIBackgroundColor}`;
    const i = document.createElement("div");
    i.style.cssText = "display:flex;flex-direction:column;gap:10px;width:min(240px,70%);padding:14px 18px;border-radius:14px;background:rgba(20,20,22,0.72);box-shadow:0 6px 24px rgba(0,0,0,0.18);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)", this.loadingText = document.createElement("div"), this.loadingText.style.cssText = "color:#fff;font:500 13px/1.3 system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;letter-spacing:0.01em;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis", this.loadingText.innerText = this.loadingUIText;
    const r = document.createElement("div");
    r.style.cssText = "height:4px;border-radius:2px;overflow:hidden;background:rgba(255,255,255,0.22)", this.loadingBar = document.createElement("div"), this.loadingBar.style.cssText = "height:100%;border-radius:2px;background:#fff;transition:width 0.2s ease", this.loadingBar.style.width = "0%", r.appendChild(this.loadingBar), i.append(this.loadingText, r), this.loadingContainer.appendChild(i), this.parentContainer.appendChild(this.loadingContainer);
  }
  displayLoadingUI() {
    this.parentContainer.appendChild(this.loadingContainer);
  }
  hideLoadingUI() {
    this.loadingContainer.remove();
  }
  lastBarWidth = "";
  lastText = "";
  downloadWeight = 0;
  trackDownload(t) {
    return this.downloadWeight = t, (e, i) => {
      const r = (e / 1048576).toFixed(1);
      if (i > 0 && e <= i) {
        const n = e / i;
        this.setBar(n * t), this.setText(`Downloading… ${Math.round(n * 100)}% (${r} MB)`);
      } else i > 0 ? (this.setBar(t), this.setText(`Downloading… ${r} MB`)) : this.setText(`Downloading… ${r} MB`);
    };
  }
  onStart(t) {
    this.onProgress(0, t);
  }
  onProgress(t, e) {
    const i = e > 0 ? Math.min(1, t / e) : 0;
    this.setBar(this.downloadWeight + (1 - this.downloadWeight) * i), this.setText(e > 1 ? `Loading ${Math.min(Math.max(1, Math.ceil(t)), e)}/${e} objects...` : this.loadingUIText);
  }
  setBar(t) {
    const e = (t * 100).toFixed(1) + "%";
    e !== this.lastBarWidth && (this.lastBarWidth = e, this.loadingBar.style.width = e);
  }
  setText(t) {
    t !== this.lastText && (this.lastText = t, this.loadingText.innerText = t);
  }
  onComplete() {
  }
};
function Ve(t) {
  return t.isPickable && t.isVisible && t.isReady() && t.isEnabled();
}
var Si = class K {
  scene;
  traceScene;
  clickToSelectEnabled = !1;
  pointerObserver = null;
  prePointerObserver = null;
  options = {};
  static CYCLE_THRESHOLD_SQUARED = 16;
  cycle = null;
  sample = null;
  candidates = null;
  selection = [];
  selecting = !1;
  pointerDownTime = 0;
  lastClick = null;
  selectionChanged = () => {
    this.selecting || this._checkSelection();
  };
  hoveredObject = null;
  pointerDownPosition = null;
  pointerDownPickInfo = null;
  static CLICK_THRESHOLD = 5;
  _dragOccurred = !1;
  _modifierActive = !1;
  _keyHandler = null;
  _blurHandler = null;
  constructor(e, i) {
    this.scene = e, this.traceScene = i;
  }
  _attachModifierTracking() {
    this._keyHandler || (this._keyHandler = (e) => {
      this._modifierActive = e.ctrlKey || e.metaKey || e.shiftKey;
    }, this._blurHandler = () => {
      this._modifierActive = !1;
    }, window.addEventListener("keydown", this._keyHandler), window.addEventListener("keyup", this._keyHandler), window.addEventListener("blur", this._blurHandler));
  }
  _detachModifierTracking() {
    this._keyHandler && (window.removeEventListener("keydown", this._keyHandler), window.removeEventListener("keyup", this._keyHandler), this._keyHandler = null), this._blurHandler && (window.removeEventListener("blur", this._blurHandler), this._blurHandler = null), this._modifierActive = !1;
  }
  enableClickToSelect(e, i) {
    i && (this.options = { ...i }, this.sample = null, this._resetCycle()), this.clickToSelectEnabled = e, e && this.scene ? (this.pointerObserver || (this.pointerObserver = this.scene.onPointerObservable.add((r) => {
      this._cycling() || this._handlePointer(r);
    }), u.log("[ClickToSelect] Added pointer observable to scene")), this._attachModifierTracking(), u.log("[ClickToSelect] Click-to-select enabled")) : e || this._detachModifierTracking(), this._configureCycleObservers();
  }
  _cycling() {
    return this.clickToSelectEnabled && this.options.cycle === !0 && !this.traceScene.isPlayMode();
  }
  _handlePointer(e) {
    e.type === U.POINTERDOWN ? this._handlePointerDown(e) : e.type === U.POINTERUP ? this._handlePointerUp(e) : e.type === U.POINTERMOVE && this._handlePointerMove(e);
  }
  _configureCycleObservers() {
    this.scene.onPrePointerObservable.remove(this.prePointerObserver), this.prePointerObserver = null, this.traceScene.getEventSystem?.()?.removeEventListener("trace-viewer:selection-changed", this.selectionChanged), this.clickToSelectEnabled && this.options.cycle ? (this.prePointerObserver = this.scene.onPrePointerObservable.add((e) => {
      this._cycling() && this._handlePointer(new Qe(e.type, e.event, e.originalPickingInfo));
    }), this.traceScene.getEventSystem?.()?.addEventListener("trace-viewer:selection-changed", this.selectionChanged)) : (this.sample = null, this._resetCycle());
  }
  _resetCycle() {
    this.cycle = null, this.lastClick = null;
  }
  _viewOf(e) {
    if (!e) return "";
    const i = this.scene.getEngine(), r = e.getViewMatrix().m, n = e.getProjectionMatrix().m, { x: a, y: s, width: o, height: c } = e.viewport;
    return [
      e.uniqueId,
      e.mode,
      e.fov,
      e.orthoLeft,
      e.orthoRight,
      e.orthoTop,
      e.orthoBottom,
      a,
      s,
      o,
      c,
      i.getRenderWidth(),
      i.getRenderHeight(),
      ...r,
      ...n
    ].join(",");
  }
  _selectionSnapshot() {
    return [this.traceScene.getSelectedObject(), ...this.options.getSelection?.() ?? []];
  }
  _checkSelection() {
    const e = this._selectionSnapshot();
    (e.length !== this.selection.length || e.some((i, r) => i !== this.selection[r])) && (this._resetCycle(), this.selection = e, this.candidates = null);
  }
  _movedFromCycle(e, i) {
    return !!this.cycle && (e - this.cycle.x) ** 2 + (i - this.cycle.y) ** 2 >= K.CYCLE_THRESHOLD_SQUARED;
  }
  _pickTargets(e, i) {
    const r = this.scene.cameraToUseForPointers ?? this.scene.activeCamera, n = this._viewOf(r);
    if (this._checkSelection(), (this._movedFromCycle(e, i) || this.cycle && this.cycle.view !== n) && this._resetCycle(), !this.sample || this.sample.x !== e || this.sample.y !== i || this.sample.view !== n) {
      const l = r ? this.scene.multiPick(e, i, (h) => Ve(h) && !h.metadata?.editorHandle && !h.name.endsWith("__collider") && !this.options.isGizmoMesh?.(h), r) ?? [] : [];
      this.sample = {
        x: e,
        y: i,
        view: n,
        hits: l.filter((h) => h.hit && h.pickedMesh).sort((h, g) => h.distance - g.distance)
      }, this.candidates = null;
    }
    if (this.candidates) return this.candidates;
    const a = [], s = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map();
    let c = !1;
    for (const l of this.sample.hits) {
      const h = this._findSceneObjectForMesh(l.pickedMesh);
      if (!h) continue;
      c = !0;
      const g = this.options.resolveSelectionUnit ? this.options.resolveSelectionUnit(h, l) : h;
      o.set(l.pickedMesh, g), g && !s.has(g) && (s.add(g), a.push(g));
    }
    if (this.cycle && (a.length !== this.cycle.targets.length || a.some((l, h) => l !== this.cycle.targets[h]))) {
      const l = this.traceScene.getSelectedObject(), h = this.cycle.shown, g = l ? [...o].find(([w, m]) => m && m !== l && h.get(w) === l)?.[1] ?? null : null, p = l ? a.indexOf(l) : -1, v = g ? a.indexOf(g) : p >= 0 ? (p + 1) % a.length : -1;
      this.cycle = v >= 0 ? {
        ...this.cycle,
        nextIndex: v,
        targets: a,
        shown: o
      } : null;
    }
    return this.candidates = {
      targets: a,
      hasContent: c,
      shown: o,
      view: n
    };
  }
  peekNextPick(e = this.scene.pointerX, i = this.scene.pointerY) {
    if (!this._cycling()) return null;
    const { targets: r } = this._pickTargets(e, i);
    return r[this.cycle?.nextIndex ?? 0] ?? null;
  }
  _selectNext(e) {
    const i = this.scene.pointerX, r = this.scene.pointerY;
    this.sample = null;
    const { targets: n, hasContent: a, shown: s, view: o } = this._pickTargets(i, r);
    if (this.lastClick && this.pointerDownTime - this.lastClick.time < si.DoubleClickDelay && (i - this.lastClick.x) ** 2 + (r - this.lastClick.y) ** 2 < K.CYCLE_THRESHOLD_SQUARED) {
      this.lastClick = null;
      return;
    }
    this.lastClick = {
      time: this.pointerDownTime,
      x: i,
      y: r
    };
    const c = this.cycle?.nextIndex ?? 0, l = n[c];
    l && (this.cycle = {
      x: i,
      y: r,
      nextIndex: (c + 1) % n.length,
      targets: n,
      shown: s,
      view: o
    }), this.selecting = !0;
    try {
      l ? this._select(l, e) : a || this.traceScene.handlePointerMiss();
    } finally {
      this.selecting = !1, this.selection = this._selectionSnapshot(), this.candidates = null;
    }
  }
  _select(e, i) {
    const r = i.event, n = r.ctrlKey || r.metaKey || r.shiftKey || typeof r.ctrlKey != "boolean" && this._modifierActive;
    this.traceScene.handlePointerEvent("select", e, !0, { additive: n });
  }
  dispose() {
    this.clickToSelectEnabled = !1, this._detachModifierTracking(), this._configureCycleObservers(), this.scene.onPointerObservable.remove(this.pointerObserver), this.pointerObserver = null;
  }
  _activeObject = null;
  notifyDragOccurred() {
    this._dragOccurred = !0, this._resetCycle();
  }
  _handlePointerDown(e) {
    if (!this.clickToSelectEnabled) return;
    const i = e.event;
    if (i.button !== 0) return;
    this.pointerDownPosition = {
      x: i.clientX,
      y: i.clientY
    }, this.pointerDownPickInfo = e, this.pointerDownTime = Date.now(), this._dragOccurred = !1;
    const r = e.pickInfo;
    if (this._cycling() || r && r.hit && r.pickedMesh) {
      const n = this._cycling() ? this.peekNextPick() : this._findSceneObjectForMesh(r.pickedMesh);
      n && (this.traceScene.handlePointerEvent("active", n, !0), this._activeObject = n);
    }
  }
  _handlePointerUp(e) {
    if (!this.clickToSelectEnabled) return;
    const i = e.event;
    if (i.button !== 0 || (this._activeObject && (this.traceScene.handlePointerEvent("active", this._activeObject, !1), this._activeObject = null), !this.pointerDownPosition || !this.pointerDownPickInfo)) return;
    const r = i.clientX - this.pointerDownPosition.x, n = i.clientY - this.pointerDownPosition.y, a = Math.sqrt(r * r + n * n), s = this.pointerDownPickInfo;
    if (this.pointerDownPosition = null, this.pointerDownPickInfo = null, a > K.CLICK_THRESHOLD) {
      u.log(`[ClickToSelect] Drag detected (${a.toFixed(1)}px) - ignoring`), this._dragOccurred = !1;
      return;
    }
    if (this._dragOccurred) {
      this._dragOccurred = !1, u.log("[ClickToSelect] Drag signalled externally - suppressing select");
      return;
    }
    if (this._cycling()) {
      this._selectNext(e);
      return;
    }
    const o = s.pickInfo;
    if (o && o.hit && o.pickedMesh) {
      const c = this._findSceneObjectForMesh(o.pickedMesh);
      u.log(`[ClickToSelect] Click on mesh "${o.pickedMesh.name}" → SceneObject "${c?.name ?? "(none)"}"`), c && this._select(c, e);
    } else
      u.log("[ClickToSelect] Click on empty space (no hit)"), this.traceScene.handlePointerMiss();
  }
  _handlePointerMove(e) {
    if (!this.clickToSelectEnabled) return;
    if (this._cycling()) {
      this.pointerDownPosition && Math.hypot(e.event.clientX - this.pointerDownPosition.x, e.event.clientY - this.pointerDownPosition.y) > K.CLICK_THRESHOLD && this.notifyDragOccurred(), this._updateHover(this.peekNextPick());
      return;
    }
    let i = e.pickInfo;
    (!i || !i.hit) && (i = this.scene.pick(this.scene.pointerX, this.scene.pointerY, Ve));
    let r = null;
    i && i.hit && i.pickedMesh && (r = this._findSceneObjectForMesh(i.pickedMesh)), this._updateHover(r);
  }
  _updateHover(e) {
    e !== this.hoveredObject && (this.hoveredObject && this.traceScene.handlePointerEvent("hover", this.hoveredObject, !1), e && this.traceScene.handlePointerEvent("hover", e, !0), this.hoveredObject = e);
  }
  _findSceneObjectForMesh(e) {
    const i = this.traceScene.getSceneObjects(), r = /* @__PURE__ */ new Map();
    for (const a of i) r.set(a.transform, a);
    let n = e;
    for (; n; ) {
      const a = r.get(n);
      if (a !== void 0) return a;
      n = n.parent;
    }
    return null;
  }
}, vi = class {
  scene;
  traceScene;
  outlineLayer = null;
  _selectionHandler = null;
  _playModeHandler = null;
  _outlinedSet = null;
  constructor(t, e) {
    this.scene = t, this.traceScene = e;
  }
  enable() {
    this.outlineLayer || (this.outlineLayer = new hi("selectionOutline", this.scene), this.outlineLayer.outlineColor = new ni(1, 0.5, 0), this.outlineLayer.outlineThickness = 2, u.log("[SelectionOutline] Created outline layer")), this._listenForEvents();
  }
  _listenForEvents() {
    const t = this.traceScene?.getEventSystem();
    t && (this._selectionHandler || (this._selectionHandler = (e) => {
      if (this._outlinedSet !== null) return;
      const i = e.detail?.object ?? null;
      this._sync(i);
    }, t.addEventListener("trace-viewer:selection-changed", this._selectionHandler)), this._playModeHandler || (this._playModeHandler = (e) => {
      if (e.detail?.playMode) this._clear();
      else {
        this._outlinedSet = null;
        const i = this.traceScene?.getSelectedObject() ?? null;
        this._sync(i);
      }
    }, t.addEventListener("trace-viewer:playmode-changed", this._playModeHandler)), u.log("[SelectionOutline] Listening for selection/playmode events"));
  }
  _removeListeners() {
    const t = this.traceScene?.getEventSystem();
    t && (this._selectionHandler && t.removeEventListener("trace-viewer:selection-changed", this._selectionHandler), this._playModeHandler && t.removeEventListener("trace-viewer:playmode-changed", this._playModeHandler)), this._selectionHandler = null, this._playModeHandler = null;
  }
  setOutlinedSet(t) {
    if (t === null || t.size === 0) {
      this._outlinedSet = null, this._sync(this.traceScene?.getSelectedObject() ?? null);
      return;
    }
    this._outlinedSet = new Set(t), this._clear();
    for (const e of this._outlinedSet) this._outline(e.transform);
    u.log(`[SelectionOutline] Outlined set of ${this._outlinedSet.size}`);
  }
  _sync(t) {
    this._clear(), t && (this._outline(t.transform), u.log(`[SelectionOutline] Outlined: ${t.name}`));
  }
  _clear() {
    this.outlineLayer?.clearSelection();
  }
  _outline(t) {
    if (!this.outlineLayer || t.isDisposed()) return;
    const e = [];
    t instanceof ai && e.push(t), e.push(...t.getChildMeshes(!1).filter((i) => !i.name.endsWith("__collider") && !i.name.endsWith("__selection"))), e.length > 0 && this.outlineLayer.addSelection(e);
  }
  resetOutlineLayer() {
    this.outlineLayer && (this._outlinedSet = null, this._removeListeners(), this.outlineLayer.dispose(), this.outlineLayer = null, this.enable());
  }
}, Xe = 0.6, We = 0.7, yi = 0.8, Ti = 0.15, bi = 1.5, ce = 5e-3, ue = "__alignmentImage";
et.ShadersStore[`${ue}VertexShader`] = `
    precision highp float;
    attribute vec3 position;
    attribute vec2 uv;
    uniform mat4 worldViewProjection;
    varying vec2 vUV;
    void main() {
        vUV = vec2(uv.x, 1.0 - uv.y);
        gl_Position = worldViewProjection * vec4(position, 1.0);
    }
`;
et.ShadersStore[`${ue}FragmentShader`] = `
    precision highp float;
    uniform sampler2D textureSampler;
    uniform float alpha;
    uniform float useTexture;
    uniform vec3 baseColor;
    varying vec2 vUV;
    void main() {
        vec3 rgb = baseColor;
        float srcA = alpha;
        if (useTexture > 0.5) {
            vec4 texel = texture2D(textureSampler, vUV);
            rgb = texel.rgb;
            srcA = texel.a * alpha;
        }
        // Premultiplied alpha output for Porter-Duff compositing.
        // The XR compositor uses framebuffer alpha to blend the camera feed,
        // so we must output correct premultiplied values.
        gl_FragColor = vec4(rgb * srcA, srcA);
    }
`;
var xi = class {
  _scene;
  _xrCamera;
  _imageUrl;
  _imageWidthMeters;
  _autoTracking;
  _root = null;
  _displayDistance = Xe;
  _targetScreenFraction = We;
  _displayWidth = 0;
  _projectionVOffset = 0;
  _imagePlane = null;
  _imageMaterial = null;
  _borderPlane = null;
  _borderMaterial = null;
  _instructionPlane = null;
  _instructionTexture = null;
  _buttonPlane = null;
  _buttonTexture = null;
  _pointerObserver = null;
  _scratchCamUp = new O();
  _renderObserver = null;
  _projWaitObserver = null;
  _instructionAnimObserver = null;
  _onConfirmCallback = null;
  constructor(t) {
    this._scene = t.scene, this._xrCamera = t.xrCamera, this._imageUrl = t.imageUrl, this._imageWidthMeters = t.imageWidthMeters, this._autoTracking = t.autoTracking ?? !1;
  }
  onConfirm(t) {
    this._onConfirmCallback = t;
  }
  show() {
    const t = this._xrCamera.getProjectionMatrix();
    if (Math.abs(t.m[0]) > 1e-6 && Math.abs(t.m[5]) > 1e-6)
      this._createOverlay(), this._startFollowingCamera();
    else {
      u.log("[ImageAlignment] Projection matrix not ready, deferring overlay creation");
      let e = 0;
      const i = this._scene.onAfterRenderObservable.add(() => {
        if (++e > 120) {
          this._scene.onAfterRenderObservable.remove(i), this._projWaitObserver = null, u.warn("[ImageAlignment] Projection matrix not ready after 120 frames, skipping overlay");
          return;
        }
        const r = this._xrCamera.getProjectionMatrix();
        Math.abs(r.m[0]) > 1e-6 && Math.abs(r.m[5]) > 1e-6 && (this._scene.onAfterRenderObservable.remove(i), this._projWaitObserver = null, this._createOverlay(), this._startFollowingCamera());
      });
      this._projWaitObserver = i;
    }
  }
  dispose() {
    this._projWaitObserver && (this._scene.onAfterRenderObservable.remove(this._projWaitObserver), this._projWaitObserver = null), this._renderObserver && (this._scene.onBeforeRenderObservable.remove(this._renderObserver), this._renderObserver = null), this._instructionAnimObserver && (this._scene.onBeforeRenderObservable.remove(this._instructionAnimObserver), this._instructionAnimObserver = null), this._pointerObserver && (this._scene.onPointerObservable.remove(this._pointerObserver), this._pointerObserver = null), this._instructionTexture?.dispose(), this._instructionTexture = null, this._buttonTexture?.dispose(), this._buttonTexture = null, this._imageMaterial?.dispose(), this._imageMaterial = null, this._borderMaterial?.dispose(), this._borderMaterial = null, this._imagePlane?.dispose(), this._imagePlane = null, this._borderPlane?.dispose(), this._borderPlane = null, this._instructionPlane?.dispose(), this._instructionPlane = null, this._buttonPlane?.dispose(), this._buttonPlane = null, this._root?.dispose(), this._root = null, this._onConfirmCallback = null;
  }
  _computeDisplayWidth() {
    const t = this._xrCamera.getProjectionMatrix(), e = Math.max(Math.abs(t.m[0]), Math.abs(t.m[5]));
    e < bi ? (this._displayDistance = yi, this._targetScreenFraction = Ti, u.log(`[ImageAlignment] Detected headset (maxScale=${e.toFixed(2)}), using distance=${this._displayDistance}m, fraction=${this._targetScreenFraction}`)) : (this._displayDistance = Xe, this._targetScreenFraction = We, u.log(`[ImageAlignment] Detected mobile (maxScale=${e.toFixed(2)}), using distance=${this._displayDistance}m, fraction=${this._targetScreenFraction}`));
    const i = t.m[5];
    return Math.abs(i) > 1e-6 && (this._projectionVOffset = this._displayDistance * t.m[9] / i), u.log(`[ImageAlignment] Projection: m[0]=${t.m[0].toFixed(4)}, m[5]=${i.toFixed(4)}, m[8]=${t.m[8].toFixed(4)}, m[9]=${t.m[9].toFixed(4)}, vCompensation=${this._projectionVOffset.toFixed(4)}m`), this._targetScreenFraction * 2 * this._displayDistance / e;
  }
  _createOverlay() {
    const t = this._scene, e = new ze("alignment-root", t);
    e.billboardMode = ze.BILLBOARDMODE_ALL, this._root = e;
    const i = this._computeDisplayWidth();
    this._displayWidth = i;
    const r = se.CreatePlane("alignment-image", {
      width: i,
      height: i
    }, t);
    r.parent = e, r.isPickable = !1, this._imagePlane = r;
    const n = new Ge("alignment-image-mat", t, ue, {
      attributes: ["position", "uv"],
      uniforms: [
        "worldViewProjection",
        "alpha",
        "useTexture",
        "baseColor"
      ],
      samplers: ["textureSampler"],
      needAlphaBlending: !0
    });
    n.backFaceCulling = !1, n.alphaMode = $e.ALPHA_PREMULTIPLIED_PORTERDUFF, n.setFloat("alpha", 0.5), n.setFloat("useTexture", 1), n.setVector3("baseColor", O.Zero()), this._imageMaterial = n;
    const a = new Ne(this._imageUrl, t, !1, !1, Ne.BILINEAR_SAMPLINGMODE);
    a.onLoadObservable.addOnce(() => {
      const c = a.getSize();
      if (n.setTexture("textureSampler", a), r.material = n, c.width > 0 && c.height > 0) {
        const l = c.width / c.height, h = i / l;
        r.scaling.y = h / i, this._repositionUI(i, h), u.log(`[ImageAlignment] Texture loaded: ${c.width}x${c.height}, aspect=${l.toFixed(2)}, displaySize=${i.toFixed(3)}x${h.toFixed(3)}m`);
      }
    });
    const s = se.CreatePlane("alignment-border", {
      width: i + ce * 2,
      height: i + ce * 2
    }, t);
    s.parent = e, s.position.z = 1e-3, s.isPickable = !1, s.renderingGroupId = 0, r.renderingGroupId = 1, this._borderPlane = s;
    const o = new Ge("alignment-border-mat", t, ue, {
      attributes: ["position", "uv"],
      uniforms: [
        "worldViewProjection",
        "alpha",
        "useTexture",
        "baseColor"
      ],
      samplers: ["textureSampler"],
      needAlphaBlending: !0
    });
    o.backFaceCulling = !1, o.alphaMode = $e.ALPHA_PREMULTIPLIED_PORTERDUFF, o.setFloat("alpha", 0.5), o.setFloat("useTexture", 0), o.setVector3("baseColor", new O(1, 1, 1)), s.material = o, this._borderMaterial = o, this._createInstructionText(i), this._createPlayButton(i), u.log(`[ImageAlignment] Overlay created (imageWidth=${this._imageWidthMeters}m, displayWidth=${i.toFixed(3)}m, distance=${this._displayDistance}m, url=${this._imageUrl})`);
  }
  _createInstructionText(t) {
    if (!this._root) return;
    const e = this._scene, i = se.CreatePlane("alignment-instruction", {
      width: Math.max(t, 0.2),
      height: 0.03
    }, e);
    i.parent = this._root, i.position.y = t / 2 + 0.04, i.isPickable = !1, this._instructionPlane = i;
    const r = Ce.CreateForMesh(i, 512, 64, !1);
    r.hasAlpha = !0, this._instructionTexture = r;
    const n = this._autoTracking ? "Scanning for image" : "Align with printed image", a = new Le("instruction-text", n);
    if (a.color = "white", a.fontSize = 36, a.fontFamily = "sans-serif", a.textHorizontalAlignment = oe.HORIZONTAL_ALIGNMENT_CENTER, a.textVerticalAlignment = oe.VERTICAL_ALIGNMENT_CENTER, r.addControl(a), this._autoTracking) {
      let s = 0;
      this._instructionAnimObserver = e.onBeforeRenderObservable.add(() => {
        const o = Math.floor(performance.now() / 500) % 4;
        o !== s && (s = o, a.text = n + ".".repeat(s));
      });
    }
  }
  _createPlayButton(t) {
    if (!this._root) return;
    const e = this._scene, i = 0.06, r = se.CreatePlane("alignment-play-button", {
      width: i,
      height: i
    }, e);
    r.parent = this._root, r.position.y = -(t / 2 + 0.04), r.isPickable = !0, this._buttonPlane = r;
    const n = Ce.CreateForMesh(r, 128, 128, !1);
    n.hasAlpha = !0, this._buttonTexture = n;
    const a = new ri("play-circle");
    a.width = "100px", a.height = "100px", a.thickness = 3, a.color = "white", a.background = "rgba(0, 180, 80, 0.8)", n.addControl(a);
    const s = new Le("play-icon", "▶");
    s.color = "white", s.fontSize = 48, s.textHorizontalAlignment = oe.HORIZONTAL_ALIGNMENT_CENTER, s.textVerticalAlignment = oe.VERTICAL_ALIGNMENT_CENTER, s.paddingLeft = "6px", a.addControl(s), this._pointerObserver = e.onPointerObservable.add((o) => {
      o.type === U.POINTERTAP && o.pickInfo?.pickedMesh === r && this._confirmAlignment();
    });
  }
  _repositionUI(t, e) {
    this._instructionPlane && (this._instructionPlane.position.y = e / 2 + 0.04), this._buttonPlane && (this._buttonPlane.position.y = -(e / 2 + 0.04)), this._borderPlane && (this._borderPlane.scaling.y = (e + ce * 2) / (this._displayWidth + ce * 2));
  }
  _startFollowingCamera() {
    this._updatePosition(), this._renderObserver = this._scene.onBeforeRenderObservable.add(() => {
      this._updatePosition();
    });
  }
  _updatePosition() {
    if (!this._root) return;
    const t = this._xrCamera.globalPosition, e = this._xrCamera.getForwardRay().direction, i = this._displayDistance, r = this._projectionVOffset;
    if (Math.abs(r) < 1e-6) this._root.position.set(t.x + e.x * i, t.y + e.y * i, t.z + e.z * i);
    else {
      O.TransformNormalToRef(O.UpReadOnly, this._xrCamera.getWorldMatrix(), this._scratchCamUp), this._scratchCamUp.normalize();
      const n = this._scratchCamUp;
      this._root.position.set(t.x + e.x * i + n.x * r, t.y + e.y * i + n.y * r, t.z + e.z * i + n.z * r);
    }
  }
  _confirmAlignment() {
    if (!this._root || !this._onConfirmCallback) return;
    const t = this._xrCamera.globalPosition, e = this._xrCamera.getForwardRay().direction, i = O.TransformNormal(O.Up(), this._xrCamera.getWorldMatrix());
    i.normalize();
    const r = this._imageWidthMeters * this._displayDistance / this._displayWidth, n = this._projectionVOffset * (r / this._displayDistance), a = new O(t.x + e.x * r + i.x * n, t.y + e.y * r + i.y * n, t.z + e.z * r + i.z * n), s = e.negate(), o = me.FromLookDirectionLH(s, i);
    u.log(`[ImageAlignment] Confirmed: anchorPos=(${a.x.toFixed(3)}, ${a.y.toFixed(3)}, ${a.z.toFixed(3)}), markerDist=${r.toFixed(3)}m (display=${this._displayDistance}m, displayW=${this._displayWidth.toFixed(3)}m, physW=${this._imageWidthMeters.toFixed(3)}m), camPos=(${t.x.toFixed(3)}, ${t.y.toFixed(3)}, ${t.z.toFixed(3)}), fwd=(${e.x.toFixed(3)}, ${e.y.toFixed(3)}, ${e.z.toFixed(3)}), camUp=(${i.x.toFixed(3)}, ${i.y.toFixed(3)}, ${i.z.toFixed(3)})`);
    const c = this._onConfirmCallback;
    this._onConfirmCallback = null, c({
      position: a,
      rotationQuaternion: o
    });
  }
};
function wi(t, e) {
  const i = e ?? new me(), r = t.y, n = t.w, a = Math.sqrt(r * r + n * n);
  return a > 1e-6 ? i.set(0, r / a, 0, n / a) : i.set(0, 0, 0, 1), i;
}
function Ei(t, e) {
  const [i, r, n, a] = t, [s, o, c, l] = e;
  return [
    a * s + i * l + r * c - n * o,
    a * o - i * c + r * l + n * s,
    a * c + i * o - r * s + n * l,
    a * l - i * s - r * o - n * c
  ];
}
function Ci(t) {
  return [
    -t[0],
    -t[1],
    -t[2],
    t[3]
  ];
}
function tt(t) {
  const e = Math.hypot(t[0], t[1], t[2], t[3]);
  return e > 1e-12 ? [
    t[0] / e,
    t[1] / e,
    t[2] / e,
    t[3] / e
  ] : [
    0,
    0,
    0,
    1
  ];
}
function fe(t, e) {
  const [i, r, n, a] = t, s = 2 * (r * e[2] - n * e[1]), o = 2 * (n * e[0] - i * e[2]), c = 2 * (i * e[1] - r * e[0]);
  return [
    e[0] + a * s + (r * c - n * o),
    e[1] + a * o + (n * s - i * c),
    e[2] + a * c + (i * o - r * s)
  ];
}
function ki(t, e) {
  const i = Math.abs(t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3]);
  return 2 * Math.acos(Math.min(1, i));
}
function Ai(t, e, i) {
  let [r, n, a, s] = e, o = t[0] * r + t[1] * n + t[2] * a + t[3] * s;
  o < 0 && (o = -o, r = -r, n = -n, a = -a, s = -s);
  let c, l;
  if (o > 0.9995)
    c = 1 - i, l = i;
  else {
    const h = Math.acos(o), g = Math.sin(h);
    c = Math.sin((1 - i) * h) / g, l = Math.sin(i * h) / g;
  }
  return tt([
    c * t[0] + l * r,
    c * t[1] + l * n,
    c * t[2] + l * a,
    c * t[3] + l * s
  ]);
}
function Pi(t) {
  const e = Math.hypot(t[1], t[3]);
  return e < 1e-9 ? [
    0,
    0,
    0,
    1
  ] : [
    0,
    t[1] / e,
    0,
    t[3] / e
  ];
}
function it(t, e) {
  const i = fe(t.q, e.t);
  return {
    t: [
      t.t[0] + i[0],
      t.t[1] + i[1],
      t.t[2] + i[2]
    ],
    q: tt(Ei(t.q, e.q))
  };
}
function Mi(t) {
  const e = Ci(t.q), i = fe(e, t.t);
  return {
    t: [
      -i[0],
      -i[1],
      -i[2]
    ],
    q: e
  };
}
function Ii(t, e) {
  const i = fe(t.q, e);
  return [
    i[0] + t.t[0],
    i[1] + t.t[1],
    i[2] + t.t[2]
  ];
}
function rt(t) {
  return Math.acos(Math.max(-1, Math.min(1, 1 - 2 * (t[0] * t[0] + t[2] * t[2]))));
}
function nt(t, e) {
  const i = Ii(t, e), r = Pi(t.q), n = fe(r, e);
  return {
    t: [
      i[0] - n[0],
      i[1] - n[1],
      i[2] - n[2]
    ],
    q: r
  };
}
function Oi(t, e = [
  0,
  0,
  0
], i = 0.85) {
  return rt(t.q) <= Math.acos(i) ? nt(t, e) : t;
}
function at(t, e) {
  return it(t, Mi(e));
}
function je(t, e) {
  return Math.hypot(t[0] - e[0], t[1] - e[1], t[2] - e[2]);
}
function Ri(t, e, i) {
  return [
    t[0] + (e[0] - t[0]) * i,
    t[1] + (e[1] - t[1]) * i,
    t[2] + (e[2] - t[2]) * i
  ];
}
function Bi() {
  return performance.now() / 1e3;
}
var Di = class {
  estimate = null;
  lastTime = -1 / 0;
  samples = 0;
  outliers = 0;
  snapped = null;
  accepted = null;
  constructor(t) {
    this.placement = t;
  }
  reset() {
    this.estimate = this.accepted = null, this.lastTime = -1 / 0, this.samples = this.outliers = 0, this.snapped = null;
  }
  observe(t, e) {
    if (this.accepted) return this.accepted;
    if (!Number.isFinite(e) || e <= this.lastTime || ![...t.t, ...t.q].every(Number.isFinite) || Math.abs(Math.hypot(...t.q) - 1) > 1e-3) return null;
    const i = at(t, this.placement);
    if (e - this.lastTime > 0.5 && (this.samples = 0), this.estimate && (je(i.t, this.estimate.t) > 0.25 || ki(i.q, this.estimate.q) > 15 * Math.PI / 180)) {
      if (++this.outliers < 8) return null;
      this.estimate = null, this.samples = 0, this.snapped = null;
    }
    this.outliers = 0;
    const r = 1 - Math.exp(-Math.min(e - this.lastTime, 1) / 0.15);
    this.estimate = this.estimate ? {
      t: Ri(this.estimate.t, i.t, r),
      q: Ai(this.estimate.q, i.q, r)
    } : i, this.lastTime = e, this.samples++;
    const n = rt(this.estimate.q), a = Math.acos(0.85), s = 3 * Math.PI / 180;
    this.snapped === null ? this.snapped = n <= a : this.snapped && n > a + s ? this.snapped = !1 : !this.snapped && n < a - s && (this.snapped = !0);
    const o = it(this.estimate, this.placement), c = Math.abs(o.q.reduce((l, h, g) => l + h * t.q[g], 0));
    return this.samples >= 40 && je(o.t, t.t) < Math.sqrt(1e-3) && c > 0.999 && (this.accepted = this.snapped ? nt(this.estimate, this.placement.t) : this.estimate), this.accepted;
  }
};
function Fi(t, e) {
  const i = ei(t);
  if (!i) return () => {
  };
  const r = i.transform.position.clone(), n = i.transform.rotationQuaternion?.clone() ?? null, a = i.transform.rotation.clone();
  return Jt(t, e), () => {
    i.transform.isDisposed() || (i.transform.position.copyFrom(r), i.transform.rotation.copyFrom(a), i.transform.rotationQuaternion = n, Qt(i));
  };
}
var xe = null;
function Li(t) {
  if (xe) return xe;
  const e = new me();
  class i extends t {
    _targetDrag(n, a) {
      wi(a, e), super._targetDrag(n, e);
    }
  }
  return xe = i, i;
}
var y = /* @__PURE__ */ (function(t) {
  return t.NOT_SUPPORTED = "not-supported", t.AVAILABLE = "available", t.ENTERING = "entering", t.ACTIVE = "active", t.EXITING = "exiting", t;
})({}), zi = class {
  _scene;
  _traceScene;
  _parentElement;
  _xrHelper = null;
  _xrInput = null;
  _state = y.NOT_SUPPORTED;
  _supported = !1;
  _savedClearColor = null;
  _uiEnabled = !1;
  _overlayContainer = null;
  _arButton = null;
  _imageAlignmentConfig = null;
  _imageAlignment = null;
  _imageTrackingFeature = null;
  _imageTrackingObserver = null;
  _selection = null;
  _sessionLocalizers = [];
  _legacyTracking = !1;
  _stabilizer = null;
  _generation = 0;
  _resetSpace = null;
  _lastScenePose = null;
  _restoreAnchorHost = null;
  _restoreContentVisibility = null;
  _onTrackingReset = () => {
    this._generation++, this._unsubscribeTracking(), this._disposeImageAlignment(), this._stabilizer?.reset(), this._lastScenePose = null, this._xrHelper && (this._xrHelper.sessionManager.referenceSpace = this._xrHelper.sessionManager.baseReferenceSpace), this._setSceneContentVisible(!1);
    const t = this._sessionLocalizers[0];
    t?.localizer && this._startImageAlignment({
      imageUrl: t.localizer.imageUrl,
      imageWidthMeters: t.localizer.widthM
    }, !!this._imageTrackingFeature), this._subscribeTracking();
  };
  _xrDragSelectionHandler = null;
  _xrDragSixDof = null;
  _xrDragTarget = null;
  _xrDragStartObserver = null;
  _clickToSelect = null;
  _xrDragSelectionEpoch = 0;
  _disposed = !1;
  constructor(t, e, i) {
    this._scene = t, this._traceScene = e, this._parentElement = i, this.checkSupport();
  }
  setClickToSelect(t) {
    this._clickToSelect = t;
  }
  get state() {
    return this._state;
  }
  get isSupported() {
    return this._supported;
  }
  get isActive() {
    return this._state === y.ACTIVE;
  }
  enableUI() {
    this._uiEnabled = !0, this._supported && this._createUI();
  }
  async checkSupport() {
    if (typeof navigator > "u" || !navigator.xr)
      return u.log("[XRManager] navigator.xr not available"), this._supported = !1, this._state = y.NOT_SUPPORTED, !1;
    try {
      const t = await navigator.xr.isSessionSupported("immersive-ar");
      return u.log(`[XRManager] immersive-ar supported: ${t}`), this._supported = t, t ? (this._state = y.AVAILABLE, this._uiEnabled && this._createUI()) : (this._state = y.NOT_SUPPORTED, this._removeUI()), t;
    } catch (t) {
      return u.warn("[XRManager] isSessionSupported check failed:", t), this._supported = !1, this._state = y.NOT_SUPPORTED, !1;
    }
  }
  setImageAlignment(t, e) {
    this._imageAlignmentConfig = {
      imageUrl: t,
      imageWidthMeters: e
    };
  }
  setLocalizers(t, e) {
    if (this._state === y.ACTIVE || this._state === y.ENTERING) throw new Error("Exit XR before changing the selected marker.");
    const i = t === null ? null : Ee(t, e);
    this._stopAutoImageTracking(), this._restoreAnchorHostPose(), this._selection = i;
  }
  _beginTrackingSession() {
    const t = this._trackingTargets();
    this._sessionLocalizers = t?.targets ?? [], this._legacyTracking = t?.legacy ?? !1, this._lastScenePose = null, this._restoreAnchorHostPose();
    const e = this._traceScene.getSceneRoot();
    if (t && e) {
      const i = e.transform.isEnabled(!1);
      this._restoreContentVisibility = () => {
        e.transform.isDisposed() || e.transform.setEnabled(i);
      }, this._setSceneContentVisible(!1);
    }
    return this._selection && (this._restoreAnchorHost = Fi(this._traceScene, this._selection.authoredPose)), t;
  }
  _trackingTargets() {
    if (this._selection) return {
      targets: [this._selection.selected],
      legacy: !1
    };
    const t = this._imageAlignmentConfig;
    return t ? {
      targets: [ii(t.imageUrl, t.imageWidthMeters)],
      legacy: !0
    } : null;
  }
  async enterXR() {
    if (this._state !== y.AVAILABLE) throw new Error(`Cannot enter XR: state is ${this._state}`);
    try {
      const t = ++this._generation;
      if (this._state = y.ENTERING, this._updateButton(), this._emitXRStateChanged(), this._xrHelper || await this._initXRHelper(), this._disposed || t !== this._generation) throw new Error("XR entry was cancelled.");
      const e = this._xrHelper;
      e.featuresManager.disableFeature(Te.IMAGE_TRACKING), this._imageTrackingFeature = null;
      const i = this._beginTrackingSession(), r = i ? {
        imageUrl: i.targets[0].localizer.imageUrl,
        imageWidthMeters: i.targets[0].localizer.widthM
      } : null;
      if (i) try {
        this._imageTrackingFeature = e.featuresManager.enableFeature(Te.IMAGE_TRACKING, "latest", { images: i.targets.map((n) => ({
          src: n.localizer.imageUrl,
          estimatedRealWorldWidth: n.localizer.widthM
        })) }, !1, !1);
      } catch {
        this._imageTrackingFeature = null;
      }
      if (this._makeBackgroundTransparent(), this._detachArcRotateCamera(), r && this._setSceneContentVisible(!1), e.camera.compensateOnFirstFrame = !1, await e.enterXRAsync("immersive-ar", "unbounded"), this._disposed || t !== this._generation)
        throw await e.exitXRAsync(), new Error("XR entry was cancelled.");
      if (r && (this._resetSpace = e.sessionManager.baseReferenceSpace, this._resetSpace.addEventListener("reset", this._onTrackingReset)), r) {
        let n = this._imageTrackingFeature?.attached ?? !1;
        !n && this._imageTrackingFeature && (n = this._imageTrackingFeature.attach(!0), n && u.log("[XRManager] Image tracking force-attached (not in session.enabledFeatures)")), this._startImageAlignment(r, n), n && this._imageTrackingFeature && this._startAutoImageTracking(this._imageTrackingFeature);
      } else {
        const n = this._traceScene.getCamera();
        n && this._positionForAROnFirstFrame(n);
      }
    } catch (t) {
      throw u.error("[XRManager] Failed to enter AR:", t), this._xrHelper?.featuresManager.disableFeature(Te.IMAGE_TRACKING), this._stopAutoImageTracking(), this._disposeImageAlignment(), this._restoreAnchorHostPose(), this._restoreBackground(), this._reattachArcRotateCamera(), this._state = this._disposed ? y.NOT_SUPPORTED : y.AVAILABLE, this._updateButton(), this._emitXRStateChanged(), t;
    }
  }
  async exitXR() {
    this._state === y.ACTIVE && (this._stopAutoImageTracking(), this._disposeImageAlignment(), this._state = y.EXITING, this._updateButton(), this._emitXRStateChanged(), await this._xrHelper?.exitXRAsync());
  }
  dispose() {
    this._disposed = !0, this._state === y.ACTIVE && this._xrHelper && this._xrHelper.exitXRAsync().catch(() => {
    }), this._teardownXRDrag(), this._disposeImageAlignment(), this._stopAutoImageTracking(), this._restoreAnchorHostPose(), this._imageTrackingFeature = null, this._xrInput?.dispose(), this._xrInput = null, this._xrHelper?.dispose(), this._xrHelper = null, this._removeUI(), this._savedClearColor = null, this._state = y.NOT_SUPPORTED;
  }
  async _initXRHelper() {
    const t = await ui.CreateAsync(this._scene);
    if (this._disposed)
      throw t.dispose(), new Error("XR manager was disposed during initialization.");
    this._xrHelper = t, this._xrHelper.onStateChangedObservable.add((e) => {
      this._onStateChanged(e);
    }), this._overlayContainer && this._xrHelper.featuresManager.enableFeature(gi, "latest", { element: this._overlayContainer }, void 0, !1), this._xrInput = new di(this._xrHelper.sessionManager, this._xrHelper.camera, { doNotLoadControllerMeshes: !0 }), this._xrHelper.featuresManager.enableFeature(mi, "latest", {
      xrInput: this._xrInput,
      disablePointerUpOnTouchOut: !1,
      forceGazeMode: !1,
      disableScenePointerVectorUpdate: !1
    }, !0, !1);
  }
  _startAutoImageTracking(t) {
    this._imageTrackingFeature = t, !this._resetSpace && this._xrHelper && (this._resetSpace = this._xrHelper.sessionManager.baseReferenceSpace, this._resetSpace.addEventListener("reset", this._onTrackingReset)), this._lastScenePose = null, this._stabilizer = this._legacyTracking ? null : new Di(this._sessionLocalizers[0]), this._subscribeTracking();
  }
  _subscribeTracking() {
    const t = this._imageTrackingFeature;
    if (!t) return;
    const e = this._generation;
    this._imageTrackingObserver = t.onTrackedImageUpdatedObservable.add((i) => {
      if (e !== this._generation || this._lastScenePose || i.emulated || i.id !== 0) return;
      const r = this._nativeTrackedImagePose(i);
      if (!r) return;
      const n = this._legacyTracking ? r : this._stabilizer?.observe(r, Bi());
      n && (this._applyTrackedScenePose(n), this._unsubscribeTracking());
    });
  }
  _unsubscribeTracking() {
    this._imageTrackingObserver && this._imageTrackingFeature?.onTrackedImageUpdatedObservable.remove(this._imageTrackingObserver), this._imageTrackingObserver = null;
  }
  _stopAutoImageTracking() {
    this._generation++, this._unsubscribeTracking(), this._resetSpace?.removeEventListener("reset", this._onTrackingReset), this._resetSpace = null, this._stabilizer = null;
  }
  _restoreAnchorHostPose() {
    this._restoreAnchorHost?.(), this._restoreAnchorHost = null, this._restoreContentVisibility?.(), this._restoreContentVisibility = null;
  }
  _nativeTrackedImagePose(t) {
    if (!this._xrHelper) return null;
    const e = this._xrHelper.sessionManager, i = e.currentFrame, r = t.xrTrackingResult;
    if (!i || !r)
      return u.warn("[XRManager] No XR frame or native tracking result — skipping"), null;
    const n = i.getPose(r.imageSpace, e.baseReferenceSpace);
    if (!n)
      return u.warn("[XRManager] Could not get native pose for tracked image"), null;
    const a = n.transform.position, s = n.transform.orientation;
    return this._legacyTracking && u.log(`[XRManager] Image tracked (native) at pos=(${a.x.toFixed(3)}, ${a.y.toFixed(3)}, ${a.z.toFixed(3)}), rot=(${s.x.toFixed(3)}, ${s.y.toFixed(3)}, ${s.z.toFixed(3)}, ${s.w.toFixed(3)})`), ti(a, s);
  }
  _applyTrackedScenePose(t) {
    if (!this._xrHelper) return;
    const e = this._xrHelper.sessionManager, i = this._lastScenePose === null;
    this._lastScenePose = t, this._disposeImageAlignment();
    const r = new XRRigidTransform({
      x: t.t[0],
      y: t.t[1],
      z: t.t[2],
      w: 1
    }, {
      x: t.q[0],
      y: t.q[1],
      z: t.q[2],
      w: t.q[3]
    });
    e.referenceSpace = e.baseReferenceSpace.getOffsetReferenceSpace(r);
    const n = new O(t.t[0], t.t[1], -t.t[2]);
    this._traceScene.setShadowPosition(n), i && this._setSceneContentVisible(!0);
  }
  _startImageAlignment(t, e) {
    if (!this._xrHelper) return;
    const i = this._xrHelper;
    u.log("[XRManager] Scheduling image alignment for first XR frame");
    const r = this._generation, n = this._scene.onBeforeRenderObservable.addOnce(() => {
      if (r !== this._generation || this._lastScenePose) return;
      const s = i.camera;
      u.log(`[XRManager] First XR frame — xrCamera pos: (${s.position.x.toFixed(2)}, ${s.position.y.toFixed(2)}, ${s.position.z.toFixed(2)})`), this._setSceneContentVisible(!1), this._imageAlignment = new xi({
        imageUrl: t.imageUrl,
        imageWidthMeters: t.imageWidthMeters,
        scene: this._scene,
        xrCamera: s,
        autoTracking: e
      }), this._imageAlignment.onConfirm((o) => {
        if (r !== this._generation) return;
        this._confirmImageAlignmentPose(o), this._imageAlignment?.dispose(), this._imageAlignment = null, this._setSceneContentVisible(!0);
        const c = this._traceScene.getSceneRoot();
        if (c) {
          c.transform.computeWorldMatrix(!0);
          const l = c.transform.getAbsolutePosition();
          u.log(`[XRManager] Image alignment complete. Scene root world pos: (${l.x.toFixed(3)}, ${l.y.toFixed(3)}, ${l.z.toFixed(3)})`);
        } else u.log("[XRManager] Image alignment complete (no scene root)");
      }), this._imageAlignment.show();
    }), a = i.onStateChangedObservable.add((s) => {
      (s === H.NOT_IN_XR || s === H.EXITING_XR) && (i.onStateChangedObservable.remove(a), this._scene.onBeforeRenderObservable.remove(n), this._disposeImageAlignment(), this._stopAutoImageTracking());
    });
  }
  _confirmImageAlignmentPose(t) {
    this._lastScenePose || (this._unsubscribeTracking(), this._lastScenePose = this._applyImageAlignmentPose(t));
  }
  _applyImageAlignmentPose(t) {
    if (!this._xrHelper) return null;
    const e = this._xrHelper.sessionManager, i = t.position, r = t.rotationQuaternion, n = me.RotationAxis(O.Up(), Math.PI), a = r.multiply(n);
    u.log(`[XRManager] Alignment pose: pos=(${i.x.toFixed(3)}, ${i.y.toFixed(3)}, ${i.z.toFixed(3)}), alignQ=(${r.x.toFixed(3)}, ${r.y.toFixed(3)}, ${r.z.toFixed(3)}, ${r.w.toFixed(3)}), finalQ=(${a.x.toFixed(3)}, ${a.y.toFixed(3)}, ${a.z.toFixed(3)}, ${a.w.toFixed(3)})`);
    let s = {
      t: [
        i.x,
        i.y,
        i.z
      ],
      q: [
        a.x,
        a.y,
        a.z,
        a.w
      ]
    };
    const o = this._sessionLocalizers[0];
    if (!this._legacyTracking && o) {
      const l = [
        o.t[0],
        o.t[1],
        o.t[2]
      ];
      s = Oi(at(s, {
        t: l,
        q: [
          o.q[0],
          o.q[1],
          o.q[2],
          o.q[3]
        ]
      }), l);
    }
    const c = new XRRigidTransform({
      x: s.t[0],
      y: s.t[1],
      z: s.t[2],
      w: 1
    }, {
      x: s.q[0],
      y: s.q[1],
      z: s.q[2],
      w: s.q[3]
    });
    return e.referenceSpace = e.baseReferenceSpace.getOffsetReferenceSpace(c), this._traceScene.setShadowPosition(new O(s.t[0], s.t[1], s.t[2])), s;
  }
  _disposeImageAlignment() {
    this._imageAlignment && (this._imageAlignment.dispose(), this._imageAlignment = null, this._setSceneContentVisible(!0));
  }
  _setSceneContentVisible(t) {
    const e = this._traceScene.getSceneRoot();
    e && (e.transform.setEnabled(t), u.log(`[XRManager] Scene content ${t ? "shown" : "hidden"}`));
  }
  _positionForAROnFirstFrame(t) {
    if (!this._xrHelper) return;
    const e = this._xrHelper, i = this._scene.onBeforeRenderObservable.addOnce(() => {
      const n = e.sessionManager, a = e.camera, s = a.position, o = a.getForwardRay().direction, c = o.x, l = o.z, h = Math.sqrt(c * c + l * l), g = 3, p = 1.6;
      let v, w;
      h > 1e-3 ? (v = c / h, w = l / h) : (v = 0, w = -1);
      const m = s.x + v * g, T = s.y - p, I = s.z + w * g, k = Math.atan2(c, l), f = t.alpha - Math.PI / 2 + k + Math.PI, P = f / 2;
      u.log(`[XRManager] AR: head=(${s.x.toFixed(2)}, ${s.y.toFixed(2)}, ${s.z.toFixed(2)}), fwd=(${v.toFixed(2)}, ${w.toFixed(2)})`), u.log(`[XRManager] AR: target=(${m.toFixed(2)}, ${T.toFixed(2)}, ${I.toFixed(2)}), yaw=${(f * 180 / Math.PI).toFixed(1)}deg`);
      const C = new XRRigidTransform({
        x: m,
        y: T,
        z: I,
        w: 1
      }), _ = new XRRigidTransform({
        x: 0,
        y: 0,
        z: 0,
        w: 1
      }, {
        x: 0,
        y: Math.sin(P),
        z: 0,
        w: Math.cos(P)
      });
      n.referenceSpace = n.baseReferenceSpace.getOffsetReferenceSpace(C).getOffsetReferenceSpace(_), this._traceScene.setShadowPosition(new O(m, T, I));
    }), r = e.onStateChangedObservable.add((n) => {
      (n === H.NOT_IN_XR || n === H.EXITING_XR) && (e.onStateChangedObservable.remove(r), this._scene.onBeforeRenderObservable.remove(i));
    });
  }
  _setupXRDrag() {
    const t = this._traceScene.getEventSystem();
    t && (this._traceScene.setCollidersDebugVisible(!1), this._xrDragSelectionHandler = (e) => {
      const i = e.detail;
      this._onXRSelectionChanged(i?.object ?? null);
    }, t.addEventListener("trace-viewer:selection-changed", this._xrDragSelectionHandler));
  }
  _teardownXRDrag() {
    this._xrDragSelectionHandler && (this._traceScene.getEventSystem()?.removeEventListener("trace-viewer:selection-changed", this._xrDragSelectionHandler), this._xrDragSelectionHandler = null), this._detachXRDragFromTarget();
  }
  async _onXRSelectionChanged(t) {
    if (this._detachXRDragFromTarget(), !t || this._state !== y.ACTIVE) return;
    const e = ++this._xrDragSelectionEpoch, { SixDofDragBehavior: i } = await import("@babylonjs/core/Behaviors/Meshes/sixDofDragBehavior.js");
    if (this._state !== y.ACTIVE || e !== this._xrDragSelectionEpoch) return;
    const r = new (Li(i))();
    r.rotateWithMotionController = !1, r.rotateDraggedObject = !1, r.detachCameraControls = !1, r.dragDeltaRatio = 1, r.allowMultiPointer = !1, r.attach(t.transform);
    const n = t.transform.getChildMeshes?.() ?? [];
    for (const a of n) a.name.endsWith("__controls") && (a.isNearGrabbable = !1);
    this._xrDragStartObserver = r.onDragStartObservable.add(() => {
      this._clickToSelect?.notifyDragOccurred();
    }), this._xrDragSixDof = r, this._xrDragTarget = t;
  }
  _detachXRDragFromTarget() {
    this._xrDragSixDof && (this._xrDragStartObserver && (this._xrDragSixDof.onDragStartObservable.remove(this._xrDragStartObserver), this._xrDragStartObserver = null), this._xrDragSixDof.detach(), this._xrDragSixDof = null), this._xrDragTarget = null;
  }
  _onStateChanged(t) {
    if (!this._disposed) {
      switch (t) {
        case H.ENTERING_XR:
          this._state = y.ENTERING, this._traceScene.setXRSessionActive(!0);
          break;
        case H.IN_XR:
          this._state = y.ACTIVE, this._setupXRDrag();
          break;
        case H.EXITING_XR:
          this._state = y.EXITING;
          break;
        case H.NOT_IN_XR:
          this._traceScene.setXRSessionActive(!1), this._teardownXRDrag(), this._stopAutoImageTracking(), this._imageTrackingFeature = null, this._restoreAnchorHostPose(), this._restoreBackground(), this._reattachArcRotateCamera(), this._state = y.AVAILABLE;
          break;
      }
      this._updateButton(), this._emitXRStateChanged();
    }
  }
  _makeBackgroundTransparent() {
    this._savedClearColor = this._scene.clearColor.clone(), this._scene.clearColor = new Je(0, 0, 0, 0), u.log("[XRManager] Background set to transparent for AR");
  }
  _restoreBackground() {
    this._savedClearColor && (this._scene.clearColor = this._savedClearColor, this._savedClearColor = null, u.log("[XRManager] Background restored"));
  }
  _detachArcRotateCamera() {
    const t = this._traceScene.getCamera();
    t && (t.detachControl(), u.log("[XRManager] ArcRotateCamera controls detached"));
  }
  _reattachArcRotateCamera() {
    const t = this._traceScene.getCamera();
    if (t) {
      const e = this._scene.getEngine().getRenderingCanvas();
      e && t.attachControl(e, !0), this._scene.activeCamera = t, u.log("[XRManager] ArcRotateCamera controls reattached");
    }
  }
  _createUI() {
    if (this._overlayContainer) return;
    const t = document.createElement("div");
    t.setAttribute("data-trace-xr-overlay", "true"), Object.assign(t.style, {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      zIndex: "10"
    });
    const e = document.createElement("button");
    e.textContent = "View in AR", e.setAttribute("data-trace-xr-button", "true"), Object.assign(e.style, {
      position: "absolute",
      bottom: "16px",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "8px 20px",
      fontSize: "14px",
      fontWeight: "600",
      color: "white",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      border: "1px solid rgba(255, 255, 255, 0.3)",
      borderRadius: "20px",
      cursor: "pointer",
      pointerEvents: "auto",
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      transition: "background-color 0.2s ease",
      outline: "none"
    }), e.addEventListener("mouseenter", () => {
      e.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
    }), e.addEventListener("mouseleave", () => {
      e.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
    }), e.addEventListener("click", () => {
      this._state === y.ACTIVE ? this.exitXR() : this._state === y.AVAILABLE && this.enterXR();
    }), t.appendChild(e), this._parentElement.appendChild(t), this._overlayContainer = t, this._arButton = e;
  }
  _updateButton() {
    if (this._arButton)
      switch (this._state) {
        case y.AVAILABLE:
          this._arButton.textContent = "View in AR", this._arButton.disabled = !1;
          break;
        case y.ENTERING:
          this._arButton.textContent = "Entering AR...", this._arButton.disabled = !0;
          break;
        case y.ACTIVE:
          this._arButton.textContent = "Exit AR", this._arButton.disabled = !1;
          break;
        case y.EXITING:
          this._arButton.textContent = "Exiting AR...", this._arButton.disabled = !0;
          break;
      }
  }
  _removeUI() {
    this._overlayContainer && (this._overlayContainer.remove(), this._overlayContainer = null, this._arButton = null);
  }
  _emitXRStateChanged() {
    const t = this._traceScene.getEventSystem();
    if (!t) return;
    const e = new CustomEvent("trace-viewer:xr-state-changed", {
      detail: {
        state: this._state,
        isActive: this._state === y.ACTIVE,
        isSupported: this._supported
      },
      bubbles: !0,
      composed: !0
    });
    t.dispatchEvent(e), u.log(`[XRManager] State changed: ${this._state}`);
  }
}, Ni = class {
  traceScene;
  _infoCache = /* @__PURE__ */ new Map();
  constructor(t) {
    this.traceScene = t;
  }
  getModelInfo(t) {
    const e = this.traceScene.resolveSceneObject(t);
    if (!e)
      return u.warn(`No scene object found for ${t}`), null;
    const i = e.transform, r = this._getAllMeshes(i);
    if (r.length === 0)
      return u.warn(`No meshes found for object ${t}`), null;
    const n = this._calculateBoundingBox(r), a = {
      x: n.max.x - n.min.x,
      y: n.max.y - n.min.y,
      z: n.max.z - n.min.z
    };
    let s = 0, o = 0;
    const c = /* @__PURE__ */ new Set();
    r.forEach((g) => {
      if (g.getVerticesData) {
        const p = g.getVerticesData(He.PositionKind);
        p && (s += p.length / 3);
      }
      if (g.getIndices) {
        const p = g.getIndices();
        p && (o += p.length / 3);
      }
      g.material && c.add(g.material.name || "UnnamedMaterial");
    });
    const l = this._getFileSize(t), h = this._getGLTFExtensions(t);
    return {
      defaultDimensions: a,
      vertexCount: Math.round(s),
      triangleCount: Math.round(o),
      materialCount: c.size,
      fileSize: l,
      gltfExtensions: h,
      boundingBox: n,
      meshCount: r.length
    };
  }
  _getAllMeshes(t) {
    const e = [];
    return t instanceof Fe && e.push(t), (t.getChildMeshes ? t.getChildMeshes(!1) : []).forEach((i) => {
      i instanceof Fe && e.push(i);
    }), e;
  }
  _calculateBoundingBox(t) {
    if (t.length === 0) return {
      min: new O(0, 0, 0),
      max: new O(0, 0, 0)
    };
    let e = 1 / 0, i = 1 / 0, r = 1 / 0, n = -1 / 0, a = -1 / 0, s = -1 / 0;
    return t.forEach((o) => {
      const c = o.getBoundingInfo(), l = c.minimum, h = c.maximum;
      e = Math.min(e, l.x), i = Math.min(i, l.y), r = Math.min(r, l.z), n = Math.max(n, h.x), a = Math.max(a, h.y), s = Math.max(s, h.z);
    }), {
      min: new O(e, i, r),
      max: new O(n, a, s)
    };
  }
  _getFileSize(t) {
    const e = this.traceScene.resolveSceneObject(t);
    if (!e) return "Unknown";
    const i = e.src;
    if (i) {
      const r = this._infoCache.get(t);
      if (r?.fileSize) {
        const n = this._formatFileSize(r.fileSize);
        return r.isEstimated ? `${n} (estimated)` : n;
      }
      return this._fetchFileSize(i).then((n) => {
        n > 0 ? (this._infoCache.set(t, {
          ...this._infoCache.get(t),
          fileSize: n
        }), u.log(`[ModelInfo] Cached actual file size for ${t}: ${this._formatFileSize(n)}`)) : this._fallbackToEstimation(t, e);
      }).catch(() => {
        this._fallbackToEstimation(t, e);
      }), "Loading...";
    }
    return "Unknown";
  }
  _fallbackToEstimation(t, e) {
    const i = e.src;
    if (i && i.toLowerCase().endsWith(".glb")) {
      const r = this._getAllMeshes(e.transform), n = this._estimateGLBSize(r);
      n > 0 && (this._infoCache.set(t, {
        ...this._infoCache.get(t),
        fileSize: n,
        isEstimated: !0
      }), u.log(`[ModelInfo] Using estimated file size for ${t}: ${this._formatFileSize(n)}`));
    }
  }
  async _fetchFileSize(t) {
    try {
      const e = await fetch(t, {
        method: "HEAD",
        mode: "cors"
      });
      if (e.ok) {
        const r = e.headers.get("content-length");
        if (r) return parseInt(r, 10);
      }
      const i = await fetch(t, {
        method: "GET",
        headers: { Range: "bytes=0-1" },
        mode: "cors"
      });
      if (i.ok) {
        const r = i.headers.get("content-range");
        if (r) {
          const n = r.match(/\/(\d+)$/);
          if (n) return parseInt(n[1], 10);
        }
      }
    } catch (e) {
      u.warn(`[ModelInfo] Failed to fetch file size for ${t}:`, e);
    }
    return 0;
  }
  _getGLTFExtensions(t) {
    const e = this.traceScene.resolveSceneObject(t);
    if (!e) return [];
    const i = this._infoCache.get(t);
    return i?.gltfExtensions ? i.gltfExtensions : e.extensionsUsed ? (this._infoCache.set(t, {
      ...this._infoCache.get(t),
      gltfExtensions: e.extensionsUsed
    }), e.extensionsUsed) : [];
  }
  _formatFileSize(t) {
    if (t === 0) return "0 Bytes";
    const e = 1024, i = [
      "Bytes",
      "KB",
      "MB",
      "GB"
    ], r = Math.floor(Math.log(t) / Math.log(e));
    return parseFloat((t / Math.pow(e, r)).toFixed(2)) + " " + i[r];
  }
  _estimateGLBSize(t) {
    let e = 0;
    return t.forEach((i) => {
      const r = i.getVerticesData(He.PositionKind);
      r && (e += r.length * 4);
      const n = i.getIndices();
      n && (e += n.length * 2), i.material && (e += 1024);
    }), e += 1024, e;
  }
  getSceneInfo() {
    const t = this.traceScene.getSceneObjects();
    if (t.length === 1 && this._isDirectMediaFile(t[0])) {
      const e = t[0].name;
      return {
        fileType: "glb",
        data: this.getModelInfo(e)
      };
    } else return {
      fileType: "trace",
      data: this._getTraceFileStats(t)
    };
  }
  _isDirectMediaFile(t) {
    const e = (t.src || "").toLowerCase();
    return e.endsWith(".glb") || e.match(/\.(jpg|jpeg|png|mp4|webm|ogg|mov|avi)$/) !== null;
  }
  _getTraceFileStats(t) {
    let e = 0, i = 0, r = 0, n = 0;
    return t.forEach((a) => {
      const s = (a.src || "").toLowerCase();
      s.endsWith(".glb") && e++, s.match(/\.(png|jpg|jpeg|gif|webp|bmp|svg)$/) && r++, s.match(/\.(mp4|webm|ogg|mov|avi)$/) && n++;
      const o = a.getSceneObjectData()?.behaviors;
      o && Array.isArray(o) && o.some((c) => c["@type"] === "ParticleSystem") && i++;
    }), {
      totalObjects: t.length,
      glbCount: e,
      particleSystemCount: i,
      imageCount: r,
      videoCount: n
    };
  }
}, $i = ArrayBuffer, A = Uint8Array, ge = Uint16Array, Hi = Int16Array, pe = Int32Array, we = function(t, e, i) {
  if (A.prototype.slice) return A.prototype.slice.call(t, e, i);
  (e == null || e < 0) && (e = 0), (i == null || i > t.length) && (i = t.length);
  var r = new A(i - e);
  return r.set(t.subarray(e, i)), r;
}, J = function(t, e, i, r) {
  if (A.prototype.fill) return A.prototype.fill.call(t, e, i, r);
  for ((i == null || i < 0) && (i = 0), (r == null || r > t.length) && (r = t.length); i < r; ++i) t[i] = e;
  return t;
}, Gi = function(t, e, i, r) {
  if (A.prototype.copyWithin) return A.prototype.copyWithin.call(t, e, i, r);
  for ((i == null || i < 0) && (i = 0), (r == null || r > t.length) && (r = t.length); i < r; ) t[e++] = t[i++];
}, Ui = [
  "invalid zstd data",
  "window size too large (>2046MB)",
  "invalid block type",
  "FSE accuracy too high",
  "match distance too far back",
  "unexpected EOF"
], M = function(t, e, i) {
  var r = new Error(e || Ui[t]);
  if (r.code = t, Error.captureStackTrace && Error.captureStackTrace(r, M), !i) throw r;
  return r;
}, qe = function(t, e, i) {
  for (var r = 0, n = 0; r < i; ++r) n |= t[e++] << (r << 3);
  return n;
}, Vi = function(t, e) {
  return (t[e] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
}, Xi = function(t, e) {
  var i = t[0] | t[1] << 8 | t[2] << 16;
  if (i == 3126568 && t[3] == 253) {
    var r = t[4], n = r >> 5 & 1, a = r >> 2 & 1, s = r & 3, o = r >> 6;
    r & 8 && M(0);
    var c = 6 - n, l = s == 3 ? 4 : s, h = qe(t, c, l);
    c += l;
    var g = o ? 1 << o : n, p = qe(t, c, g) + (o == 1 && 256), v = p;
    if (!n) {
      var w = 1 << 10 + (t[5] >> 3);
      v = w + (w >> 3) * (t[5] & 7);
    }
    v > 2145386496 && M(1);
    var m = new A((e == 1 ? p || v : e ? 0 : v) + 12);
    return m[0] = 1, m[4] = 4, m[8] = 8, {
      b: c + g,
      y: 0,
      l: 0,
      d: h,
      w: e && e != 1 ? e : m.subarray(12),
      e: v,
      o: new pe(m.buffer, 0, 3),
      u: p,
      c: a,
      m: Math.min(131072, v)
    };
  } else if ((i >> 4 | t[3] << 20) == 25481893) return Vi(t, 4) + 8;
  M(0);
}, V = function(t) {
  for (var e = 0; 1 << e <= t; ++e) ;
  return e - 1;
}, ee = function(t, e, i) {
  var r = (e << 3) + 4, n = (t[e] & 15) + 5;
  n > i && M(3);
  for (var a = 1 << n, s = a, o = -1, c = -1, l = -1, h = a, g = new $i(512 + (a << 2)), p = new Hi(g, 0, 256), v = new ge(g, 0, 256), w = new ge(g, 512, a), m = 512 + (a << 1), T = new A(g, m, a), I = new A(g, m + a); o < 255 && s > 0; ) {
    var k = V(s + 1), f = r >> 3, P = (1 << k + 1) - 1, C = (t[f] | t[f + 1] << 8 | t[f + 2] << 16) >> (r & 7) & P, _ = (1 << k) - 1, R = P - s - 1, D = C & _;
    if (D < R ? (r += k, C = D) : (r += k + 1, C > _ && (C -= R)), p[++o] = --C, C == -1 ? (s += C, T[--h] = o) : s -= C, !C) do {
      var z = r >> 3;
      c = (t[z] | t[z + 1] << 8) >> (r & 7) & 3, r += 2, o += c;
    } while (c == 3);
  }
  (o > 255 || s) && M(0);
  for (var B = 0, N = (a >> 1) + (a >> 3) + 3, $ = a - 1, L = 0; L <= o; ++L) {
    var E = p[L];
    if (E < 1) {
      v[L] = -E;
      continue;
    }
    for (l = 0; l < E; ++l) {
      T[B] = L;
      do
        B = B + N & $;
      while (B >= h);
    }
  }
  for (B && M(0), l = 0; l < a; ++l) {
    var S = v[T[l]]++;
    w[l] = (S << (I[l] = n - V(S))) - a;
  }
  return [r + 7 >> 3, {
    b: n,
    s: T,
    n: I,
    t: w
  }];
}, Wi = function(t, e) {
  var i = 0, r = -1, n = new A(292), a = t[e], s = n.subarray(0, 256), o = n.subarray(256, 268), c = new ge(n.buffer, 268);
  if (a < 128) {
    var l = ee(t, e + 1, 6), h = l[0], g = l[1];
    e += a;
    var p = h << 3, v = t[e];
    v || M(0);
    for (var w = 0, m = 0, T = g.b, I = T, k = (++e << 3) - 8 + V(v); k -= T, !(k < p); ) {
      var f = k >> 3;
      if (w += (t[f] | t[f + 1] << 8) >> (k & 7) & (1 << T) - 1, s[++r] = g.s[w], k -= I, k < p) break;
      f = k >> 3, m += (t[f] | t[f + 1] << 8) >> (k & 7) & (1 << I) - 1, s[++r] = g.s[m], T = g.n[w], w = g.t[w], I = g.n[m], m = g.t[m];
    }
    ++r > 255 && M(0);
  } else {
    for (r = a - 127; i < r; i += 2) {
      var P = t[++e];
      s[i] = P >> 4, s[i + 1] = P & 15;
    }
    ++e;
  }
  var C = 0;
  for (i = 0; i < r; ++i) {
    var _ = s[i];
    _ > 11 && M(0), C += _ && 1 << _ - 1;
  }
  var R = V(C) + 1, D = 1 << R, z = D - C;
  for (z & z - 1 && M(0), s[r++] = V(z) + 1, i = 0; i < r; ++i) {
    var _ = s[i];
    ++o[s[i] = _ && R + 1 - _];
  }
  var B = new A(D << 1), N = B.subarray(0, D), $ = B.subarray(D);
  for (c[R] = 0, i = R; i > 0; --i) {
    var L = c[i];
    J($, i, L, c[i - 1] = L + o[i] * (1 << R - i));
  }
  for (c[0] != D && M(0), i = 0; i < r; ++i) {
    var E = s[i];
    if (E) {
      var S = c[E];
      J(N, i, S, c[E] = S + (1 << R - E));
    }
  }
  return [e, {
    n: $,
    b: R,
    s: N
  }];
}, ji = ee(/* @__PURE__ */ new A([
  81,
  16,
  99,
  140,
  49,
  198,
  24,
  99,
  12,
  33,
  196,
  24,
  99,
  102,
  102,
  134,
  70,
  146,
  4
]), 0, 6)[1], qi = ee(/* @__PURE__ */ new A([
  33,
  20,
  196,
  24,
  99,
  140,
  33,
  132,
  16,
  66,
  8,
  33,
  132,
  16,
  66,
  8,
  33,
  68,
  68,
  68,
  68,
  68,
  68,
  68,
  68,
  36,
  9
]), 0, 6)[1], Yi = ee(/* @__PURE__ */ new A([
  32,
  132,
  16,
  66,
  102,
  70,
  68,
  68,
  68,
  68,
  36,
  73,
  2
]), 0, 5)[1], st = function(t, e) {
  for (var i = t.length, r = new pe(i), n = 0; n < i; ++n)
    r[n] = e, e += 1 << t[n];
  return r;
}, ke = /* @__PURE__ */ new A((/* @__PURE__ */ new pe([
  0,
  0,
  0,
  0,
  16843009,
  50528770,
  134678020,
  202050057,
  269422093
])).buffer, 0, 36), Zi = /* @__PURE__ */ st(ke, 0), Ae = /* @__PURE__ */ new A((/* @__PURE__ */ new pe([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  16843009,
  50528770,
  117769220,
  185207048,
  252579084,
  16
])).buffer, 0, 53), Ki = /* @__PURE__ */ st(Ae, 3), Q = function(t, e, i) {
  var r = t.length, n = e.length, a = t[r - 1], s = (1 << i.b) - 1, o = -i.b;
  a || M(0);
  for (var c = 0, l = i.b, h = (r << 3) - 8 + V(a) - l, g = -1; h > o && g < n; ) {
    var p = h >> 3, v = (t[p] | t[p + 1] << 8 | t[p + 2] << 16) >> (h & 7);
    c = (c << l | v) & s, e[++g] = i.s[c], h -= l = i.n[c];
  }
  (h != o || g + 1 != n) && M(0);
}, Qi = function(t, e, i) {
  var r = 6, n = e.length + 3 >> 2, a = n << 1, s = n + a;
  Q(t.subarray(r, r += t[0] | t[1] << 8), e.subarray(0, n), i), Q(t.subarray(r, r += t[2] | t[3] << 8), e.subarray(n, a), i), Q(t.subarray(r, r += t[4] | t[5] << 8), e.subarray(a, s), i), Q(t.subarray(r), e.subarray(s), i);
}, Ji = function(t, e, i) {
  var r, n = e.b, a = t[n], s = a >> 1 & 3;
  e.l = a & 1;
  var o = a >> 3 | t[n + 1] << 5 | t[n + 2] << 13, c = (n += 3) + o;
  if (s == 1)
    return n >= t.length ? void 0 : (e.b = n + 1, i ? (J(i, t[n], e.y, e.y += o), i) : J(new A(o), t[n]));
  if (!(c > t.length)) {
    if (s == 0)
      return e.b = c, i ? (i.set(t.subarray(n, c), e.y), e.y += o, i) : we(t, n, c);
    if (s == 2) {
      var l = t[n], h = l & 3, g = l >> 2 & 3, p = l >> 4, v = 0, w = 0;
      h < 2 ? g & 1 ? p |= t[++n] << 4 | (g & 2 && t[++n] << 12) : p = l >> 3 : (w = g, g < 2 ? (p |= (t[++n] & 63) << 4, v = t[n] >> 6 | t[++n] << 2) : g == 2 ? (p |= t[++n] << 4 | (t[++n] & 3) << 12, v = t[n] >> 2 | t[++n] << 6) : (p |= t[++n] << 4 | (t[++n] & 63) << 12, v = t[n] >> 6 | t[++n] << 2 | t[++n] << 10)), ++n;
      var m = i ? i.subarray(e.y, e.y + e.m) : new A(e.m), T = m.length - p;
      if (h == 0) m.set(t.subarray(n, n += p), T);
      else if (h == 1) J(m, t[n++], T);
      else {
        var I = e.h;
        if (h == 2) {
          var k = Wi(t, n);
          v += n - (n = k[0]), e.h = I = k[1];
        } else I || M(0);
        (w ? Qi : Q)(t.subarray(n, n += v), m.subarray(T), I);
      }
      var f = t[n++];
      if (f) {
        f == 255 ? f = (t[n++] | t[n++] << 8) + 32512 : f > 127 && (f = f - 128 << 8 | t[n++]);
        var P = t[n++];
        P & 3 && M(0);
        for (var C = [
          qi,
          Yi,
          ji
        ], _ = 2; _ > -1; --_) {
          var R = P >> (_ << 1) + 2 & 3;
          if (R == 1) {
            var D = new A([
              0,
              0,
              t[n++]
            ]);
            C[_] = {
              s: D.subarray(2, 3),
              n: D.subarray(0, 1),
              t: new ge(D.buffer, 0, 1),
              b: 0
            };
          } else R == 2 ? (r = ee(t, n, 9 - (_ & 1)), n = r[0], C[_] = r[1]) : R == 3 && (e.t || M(0), C[_] = e.t[_]);
        }
        var z = e.t = C, B = z[0], N = z[1], $ = z[2], L = t[c - 1];
        L || M(0);
        var E = (c << 3) - 8 + V(L) - $.b, S = E >> 3, F = 0, te = (t[S] | t[S + 1] << 8) >> (E & 7) & (1 << $.b) - 1;
        S = (E -= N.b) >> 3;
        var ie = (t[S] | t[S + 1] << 8) >> (E & 7) & (1 << N.b) - 1;
        S = (E -= B.b) >> 3;
        var re = (t[S] | t[S + 1] << 8) >> (E & 7) & (1 << B.b) - 1;
        for (++f; --f; ) {
          var _e = $.s[te], Pe = $.n[te], Se = B.s[re], Me = B.n[re], Ie = N.s[ie], Oe = N.n[ie];
          S = (E -= Ie) >> 3;
          var Re = 1 << Ie, G = Re + ((t[S] | t[S + 1] << 8 | t[S + 2] << 16 | t[S + 3] << 24) >>> (E & 7) & Re - 1);
          S = (E -= Ae[Se]) >> 3;
          var X = Ki[Se] + ((t[S] | t[S + 1] << 8 | t[S + 2] << 16) >> (E & 7) & (1 << Ae[Se]) - 1);
          S = (E -= ke[_e]) >> 3;
          var ne = Zi[_e] + ((t[S] | t[S + 1] << 8 | t[S + 2] << 16) >> (E & 7) & (1 << ke[_e]) - 1);
          if (S = (E -= Pe) >> 3, te = $.t[te] + ((t[S] | t[S + 1] << 8) >> (E & 7) & (1 << Pe) - 1), S = (E -= Me) >> 3, re = B.t[re] + ((t[S] | t[S + 1] << 8) >> (E & 7) & (1 << Me) - 1), S = (E -= Oe) >> 3, ie = N.t[ie] + ((t[S] | t[S + 1] << 8) >> (E & 7) & (1 << Oe) - 1), G > 3)
            e.o[2] = e.o[1], e.o[1] = e.o[0], e.o[0] = G -= 3;
          else {
            var ae = G - (ne != 0);
            ae ? (G = ae == 3 ? e.o[0] - 1 : e.o[ae], ae > 1 && (e.o[2] = e.o[1]), e.o[1] = e.o[0], e.o[0] = G) : G = e.o[0];
          }
          for (var _ = 0; _ < ne; ++_) m[F + _] = m[T + _];
          F += ne, T += ne;
          var W = F - G;
          if (W < 0) {
            var j = -W, ct = e.e + W;
            j > X && (j = X);
            for (var _ = 0; _ < j; ++_) m[F + _] = e.w[ct + _];
            F += j, X -= j, W = 0;
          }
          for (var _ = 0; _ < X; ++_) m[F + _] = m[W + _];
          F += X;
        }
        if (F != T) for (; T < m.length; ) m[F++] = m[T++];
        else F = m.length;
        i ? e.y += F : m = we(m, 0, F);
      } else if (i) {
        if (e.y += p, T) for (var _ = 0; _ < p; ++_) m[_] = m[T + _];
      } else T && (m = we(m, T));
      return e.b = c, m;
    }
    M(2);
  }
}, er = function(t, e) {
  if (t.length == 1) return t[0];
  for (var i = new A(e), r = 0, n = 0; r < t.length; ++r) {
    var a = t[r];
    i.set(a, n), n += a.length;
  }
  return i;
};
function ot(t, e) {
  for (var i = [], r = +!e, n = 0, a = 0; t.length; ) {
    var s = Xi(t, r || e);
    if (typeof s == "object") {
      for (r ? (e = null, s.w.length == s.u && (i.push(e = s.w), a += s.u)) : (i.push(e), s.e = 0); !s.l; ) {
        var o = Ji(t, s, e);
        o || M(5), e ? s.e = s.y : (i.push(o), a += o.length, Gi(s.w, 0, o.length), s.w.set(o, s.w.length - o.length));
      }
      n = s.b + s.c * 4;
    } else n = s;
    t = t.subarray(n);
  }
  return er(i, a);
}
var tr = 31, ir = 139, rr = 4247762216, de = 1347635022, le = 32, nr = 1, ar = 2, sr = 2914910211, or = /* @__PURE__ */ new Set([0, 4]), Ye = 4, cr = 1024, lr = 9, Ze = 16;
function hr(t) {
  const e = new Uint8Array(t, 0, Math.min(4, t.byteLength));
  if (e[0] === tr && e[1] === ir) return "gzip";
  if (t.byteLength >= 4) {
    const i = new DataView(t);
    if (i.getUint32(0, !0) === rr) return "zstd";
    if (t.byteLength >= 8 && i.getUint32(0, !0) === de && i.getUint32(4, !0) >= 4) return "v4";
  }
  return "raw";
}
function ur(t, e, i) {
  const r = new DataView(t);
  let n = e;
  for (; n + 8 <= i; ) {
    const a = r.getUint32(n, !0), s = r.getUint32(n + 4, !0);
    if (a === sr && s >= 4 && n + 12 <= i) {
      const o = r.getUint32(n + 8, !0);
      or.has(o) || u.warn(`[SPZLoaderPlugin] SPZ declares coordinate system ${o} via extension; it is not applied, the data is treated as RUB and may appear misoriented`);
    }
    n += 8 + s;
  }
}
function gr(t) {
  const e = new DataView(t), i = e.getUint32(4, !0);
  if (i !== 4) throw new Error(`Unsupported SPZ version: ${i} (expected 2, 3 or 4)`);
  if (t.byteLength < le) throw new Error(`SPZ v4 data too small: ${t.byteLength} bytes (minimum ${le})`);
  const r = e.getUint32(8, !0), n = e.getUint8(12), a = e.getUint8(13), s = e.getUint8(14), o = e.getUint8(15), c = e.getUint32(16, !0);
  if (n > Ye) throw new Error(`Unsupported SPZ SH degree: ${n} (maximum ${Ye})`);
  if (r === 0 || r > t.byteLength * cr / lr) throw new Error(`Invalid SPZ v4 point count: ${r} for a ${t.byteLength}-byte file`);
  const l = (n + 1) * (n + 1) - 1, h = [
    r * 9,
    r,
    r * 3,
    r * 3,
    r * 4,
    r * l * 3
  ].filter((f) => f > 0);
  if (o !== h.length) throw new Error(`Unsupported SPZ v4 stream count: ${o} (expected ${h.length})`);
  const g = c + o * 16;
  if (c < le || g > t.byteLength) throw new Error(`Invalid SPZ v4 table of contents offset: ${c}`);
  s & ar && ur(t, le, c);
  const p = [];
  let v = g;
  for (let f = 0; f < o; f++) {
    const P = Number(e.getBigUint64(c + f * 16, !0)), C = Number(e.getBigUint64(c + f * 16 + 8, !0));
    if (C !== h[f]) throw new Error(`SPZ v4 stream ${f} has ${C} bytes, expected ${h[f]} for ${r} points`);
    if (v += P, v > t.byteLength) throw new Error(`SPZ v4 stream ${f} is truncated`);
    p.push(P);
  }
  const w = h.reduce((f, P) => f + P, Ze), m = new Uint8Array(w), T = new DataView(m.buffer);
  T.setUint32(0, de, !0), T.setUint32(4, 3, !0), T.setUint32(8, r, !0), m[12] = n, m[13] = a, m[14] = s & nr, m[15] = 0;
  let I = g, k = Ze;
  for (let f = 0; f < o; f++) {
    const P = ot(new Uint8Array(t, I, p[f]));
    if (P.byteLength !== h[f]) throw new Error(`SPZ v4 stream ${f} decompressed to ${P.byteLength} bytes, expected ${h[f]}`);
    m.set(P, k), I += p[f], k += h[f];
  }
  return m.buffer;
}
async function dr(t) {
  const e = new ReadableStream({ start(i) {
    i.enqueue(new Uint8Array(t)), i.close();
  } }).pipeThrough(new DecompressionStream("gzip"));
  return new Response(e).arrayBuffer();
}
async function mr(t) {
  switch (hr(t)) {
    case "gzip":
      return dr(t);
    case "v4":
      return gr(t);
    case "zstd": {
      const e = ot(new Uint8Array(t));
      return new Uint8Array(e).buffer;
    }
    case "raw":
      return t;
  }
}
function fr(t) {
  if (t.byteLength < 16) throw new Error(`SPZ data too small: ${t.byteLength} bytes (minimum 16)`);
  const e = new DataView(t).getUint32(0, !0);
  if (e !== de) throw new Error(`Invalid SPZ magic: 0x${e.toString(16).padStart(8, "0")} (expected 0x${de.toString(16).padStart(8, "0")})`);
  const i = new DataView(t).getUint32(4, !0);
  if (i !== 2 && i !== 3) throw new Error(`Unsupported SPZ version: ${i} (expected 2 or 3)`);
}
var pr = class {
  name = "spz";
  extensions = { ".spz": { isBinary: !0 } };
  async importMeshAsync(t, e, i, r, n, a) {
    const s = await mr(i);
    fr(s);
    const o = await pi(s, e, {});
    if (!o.data || !o.data.byteLength) throw new Error("ParseSpz returned empty data");
    const c = new fi("GaussianSplatting", null, e);
    if (o.trainedWithAntialiasing) {
      const l = c.material;
      l.kernelSize = 0.1, l.compensation = !0;
    }
    return c.updateData(o.data, o.sh, { flipY: !1 }, void 0, o.shDegree), {
      meshes: [c],
      particleSystems: [],
      skeletons: [],
      animationGroups: [],
      transformNodes: [],
      geometries: [],
      lights: [],
      spriteManagers: []
    };
  }
  async loadAsync(t, e, i, r, n) {
    await this.importMeshAsync(null, t, e, i, r, n);
  }
  async loadAssetContainerAsync(t, e, i, r, n) {
    const a = new ci(t);
    t._blockEntityCollection = !0;
    try {
      const s = await this.importMeshAsync(null, t, e, i, r, n);
      for (const o of s.meshes) a.meshes.push(o);
    } finally {
      t._blockEntityCollection = !1;
    }
    return a;
  }
}, Ke = !1;
function _r() {
  Ke || (Z({
    name: "trace",
    extensions: { ".trace": { isBinary: !0 } },
    createPlugin: () => new Wt()
  }), Z({
    name: "bundle",
    extensions: {
      ".glz": { isBinary: !0 },
      ".tracex": { isBinary: !0 }
    },
    createPlugin: () => new Vt()
  }), Z({
    name: "glxf",
    extensions: { ".glxf": { isBinary: !1 } },
    createPlugin: () => new Zt()
  }), Z({
    name: "aero",
    extensions: { ".real": { isBinary: !0 } },
    createPlugin: () => new Ut()
  }), Z({
    name: "spz",
    extensions: { ".spz": { isBinary: !0 } },
    createPlugin: () => new pr()
  }), Ke = !0);
}
var Sr = class he extends HTMLElement {
  canvas;
  engine = null;
  traceScene = null;
  loaded = !1;
  get scene() {
    return this.traceScene?.getBabylonScene() ?? null;
  }
  clickToSelect = null;
  selectionOutline = null;
  xrManager = null;
  modelInfo = null;
  _localizers = null;
  _selectedPlacementId;
  _imageAlignmentConfig = null;
  exporter() {
    if (!this.traceScene) throw new Error("Scene is not initialized");
    return new Kt(this.traceScene);
  }
  _pendingEditModeClickToSelect = null;
  _clickToSelectOptions = {};
  _resizeHandler = null;
  _ready = !1;
  _readyPromise = null;
  _readyResolve = null;
  _readyReject = null;
  constructor() {
    super(), this.canvas = document.createElement("canvas"), this.initializeStyle();
  }
  getCanvas() {
    return this.canvas;
  }
  getEngine() {
    return this.engine;
  }
  startRendering() {
    this.traceScene?.startRendering();
  }
  setBackgroundColor(e) {
    const i = this.traceScene?.getBabylonScene();
    i && (i.clearColor = Je.FromHexString(e.length === 7 ? e + "ff" : e));
  }
  frameScene() {
    this.traceScene?.frameScene();
  }
  resetCamera(e = !0) {
    if (!this.traceScene) {
      u.log("[TraceViewer] Cannot reset camera - scene not initialized");
      return;
    }
    const i = this.traceScene.getCamera();
    if (!i) {
      u.log("[TraceViewer] Cannot reset camera - no camera found");
      return;
    }
    ve.resetCamera(this.traceScene.getBabylonScene(), i, e, this.traceScene.safeAreaInsets);
  }
  focusObject(e, i) {
    const r = this.traceScene?.getCamera();
    if (!r) {
      u.log("[TraceViewer] Cannot focus object - no camera found");
      return;
    }
    ve.focusOnNode(r, e.transform, i, this.traceScene?.safeAreaInsets);
  }
  focusObjects(e, i) {
    if (e.length === 0) return;
    const r = this.traceScene?.getCamera();
    if (!r) {
      u.log("[TraceViewer] Cannot focus objects - no camera found");
      return;
    }
    ve.focusOnNodes(r, e.map((n) => n.transform), i, this.traceScene?.safeAreaInsets);
  }
  whenReady() {
    return this._ready ? Promise.resolve() : (this._readyPromise || (this._readyPromise = new Promise((e, i) => {
      this._readyResolve = e, this._readyReject = i;
    })), this._readyPromise);
  }
  get isReady() {
    return this._ready;
  }
  initializeStyle() {
    if (!document.querySelector("style[data-trace-viewer-global]")) {
      const e = document.createElement("style");
      e.setAttribute("data-trace-viewer-global", "true"), e.textContent = `
                trace-viewer {
                    display: block;
                    width: 100%;
                    height: 100%;
                    position: relative;
                    user-select: none;
                    -webkit-user-select: none;
                }
                trace-viewer canvas {
                    width: 100%;
                    height: 100%;
                    outline: none;
                    cursor: grab;
                    touch-action: none;
                }
            `, document.head.appendChild(e);
    }
  }
  static TRACE_FORMAT_EXTENSIONS = [
    "glz",
    "zip",
    "trace",
    "tracex",
    "glxf",
    "real"
  ];
  static SNIFF_DOWNLOAD_WEIGHT = 0.1;
  async open(e) {
    const i = ye.getFileExtensionFromSrc(e.src);
    return he.TRACE_FORMAT_EXTENSIONS.includes(i) ? this._loadAsTraceFormat(e) : Be(i) || !i ? this._openByContent(e) : this._loadAsSingleAsset(e);
  }
  async _openByContent(e) {
    if (!this.traceScene) throw new Error("Scene not initialized");
    const i = he.SNIFF_DOWNLOAD_WEIGHT, r = await this.traceScene.fetchAssetWithProgress(e.src, (s, o) => {
      e.onProgress?.(i * (o > 0 ? Math.min(1, s / o) : 0));
    }, { revalidate: !!e.revalidate }).catch((s) => {
      throw Y(this), s;
    }), n = ye.getFileExtensionFromSrc(r.fileName);
    if (he.TRACE_FORMAT_EXTENSIONS.includes(n)) return this._loadAsTraceFormat(e, r);
    const a = Be(n) || !n ? await Yt(r.blob) : void 0;
    return Y(this), !a || !qt(a) ? this._loadAsSingleAsset(e, r) : (e.behaviors?.length && u.warn(`[TraceViewer] Ignoring ${e.behaviors.length} externally-stored behaviors for ${e.src}: a scene document carries its own root behaviors.`), this._loadAsTraceFormat({
      ...e,
      behaviors: void 0
    }, r));
  }
  async _loadAsTraceFormat(e, i) {
    if (!this.traceScene || !this.engine) throw new Error("Scene not initialized");
    const r = this._beginLoad();
    try {
      this.traceScene.clearScene();
      const a = r.trackDownload(0.1), { blob: s, fileName: o, assetBaseUrl: c } = i ?? await this.traceScene.fetchAssetWithProgress(e.src, (h, g) => {
        a(h, g), e.onProgress?.(0.1 * (g > 0 ? Math.min(1, h / g) : 0));
      }, { revalidate: !!e.revalidate });
      let l = -1;
      await this.traceScene.loadFromBlob(s, o, {
        onStart: (h) => {
          r.onStart(h), u.log(`[TraceViewer] progress onStart: total=${h}`), e.onProgress?.(0.1);
        },
        onProgress: (h, g) => {
          r.onProgress(h, g);
          const p = g > 0 ? h / g : 0, v = 0.1 + (1 - 0.1) * p, w = Math.floor(v * 100);
          w !== l && (l = w, u.log(`[TraceViewer] progress: ${h.toFixed(2)}/${g} → ${w}%`)), e.onProgress?.(v);
        },
        onComplete: () => {
          r.onComplete(), u.log("[TraceViewer] progress onComplete");
        }
      }, e.behaviors, c), this._finishLoad(e.deferRendering ?? !1), u.log(`[TraceViewer] Opened trace-format: ${e.src} (${e.behaviors?.length ?? 0} extra behaviors)`);
    } catch (n) {
      this._loadFailed(n, e.src);
    } finally {
      this.engine?.hideLoadingUI();
    }
  }
  async _loadAsSingleAsset(e, i) {
    if (!this.traceScene || !this.engine) throw new Error("Scene not initialized");
    const r = this._beginLoad();
    try {
      const a = {
        onStart: (o) => {
          r.onStart(o), e.onProgress?.(0.9);
        },
        onProgress: (o, c) => {
          r.onProgress(o, c), e.onProgress?.(0.9 + 0.09999999999999998 * (c > 0 ? o / c : 0));
        },
        onComplete: () => {
          r.onComplete();
        }
      }, s = r.trackDownload(0.9);
      await this.traceScene.openAsRoot(e.src, e.behaviors, (o, c) => {
        s(o, c), e.onProgress?.(0.9 * (c > 0 ? Math.min(1, o / c) : 0));
      }, a, i, { revalidate: !!e.revalidate }), this._finishLoad(e.deferRendering ?? !1), u.log(`[TraceViewer] Opened asset: ${e.src} (${e.behaviors?.length ?? 0} extra behaviors)`);
    } catch (n) {
      this._loadFailed(n, e.src);
    } finally {
      this.engine?.hideLoadingUI();
    }
  }
  _loadFailed(e, i) {
    throw Y(this), u.error(`[TraceViewer] Error opening ${i}: ${String(e)}`), e;
  }
  _beginLoad() {
    const e = new be("Loading...", this);
    return this.engine.loadingScreen = e, this.engine.displayLoadingUI(), e;
  }
  _finishLoad(e) {
    Y(this), this.resetAfterClear(), e || (this.traceScene.frameScene(), this.traceScene.startRendering());
  }
  async openBlob(e, i, r) {
    if (!this.traceScene || !this.engine) throw new Error("Scene not initialized");
    const n = new be("Loading...", this);
    this.engine.loadingScreen = n, this.engine.displayLoadingUI();
    try {
      this.traceScene.clearScene(), r?.siblings?.size && this.traceScene.resources.registerSiblingAssets(r.siblings), await this.traceScene.loadFromBlob(e, i, n), this._finishLoad(!1), u.log(`[TraceViewer] Opened blob: ${i}`);
    } catch (a) {
      this._loadFailed(a, `blob ${i}`);
    } finally {
      this.engine?.hideLoadingUI();
    }
  }
  resetAfterClear() {
    this.selectionOutline?.resetOutlineLayer(), this.engine?.resize();
  }
  clearScene() {
    this.traceScene && (this.traceScene.clearScene(), this.resetAfterClear());
  }
  async import(e, i, ...r) {
    if (!this.traceScene) throw new Error("Scene not initialized");
    let n;
    if (typeof e == "string") {
      const { behaviors: a, options: s } = De(r);
      n = await this.traceScene.loadAsset(e, i, a, s);
    } else {
      if (!i) throw new Error("fileName is required when importing from Blob");
      const { name: a, behaviors: s, options: o } = De(r);
      n = await this.traceScene.loadAsset(e, i, a, s, o);
    }
    if (!n) throw new Error("No objects loaded");
    return {
      sceneObject: n,
      behaviors: n.getBehaviors(),
      errors: void 0
    };
  }
  async unpack(e, i = {}) {
    if (!this.traceScene) throw new Error("Scene not initialized");
    return this.traceScene.unpackReference(e, i);
  }
  async placeCopy(e, i, r = {}) {
    if (!this.traceScene) throw new Error("Scene not initialized");
    return this.traceScene.placeCopy(e, i, r);
  }
  registerExternalAssets(e) {
    if (!this.traceScene) throw new Error("Scene not initialized");
    this.traceScene.resources.registerSiblingAssets(e);
  }
  async exportToBlob(e = {}) {
    return this.exporter().toTraceBlob(e);
  }
  async exportSubtreeToBlob(e, i = {}) {
    return this.exporter().subtreeToTraceBlob(e, i);
  }
  async exportToGlzBlob(e = {}) {
    return this.exporter().toGlzBlob(e);
  }
  async exportSubtreeToGlzBlob(e, i = {}) {
    return this.exporter().subtreeToGlzBlob(e, i);
  }
  async exportToTracexBlob(e = {}) {
    return this.exportToGlzBlob(e);
  }
  async exportSubtreeToTracexBlob(e, i = {}) {
    return this.exportSubtreeToGlzBlob(e, i);
  }
  async exportSceneToGltfBlob(e = {}) {
    return this.exporter().toGltfBlob(e);
  }
  async exportSceneToGlxfBlob(e = {}) {
    return this.exportSceneToGltfBlob(e);
  }
  async exportSceneFolder(e = {}) {
    return this.exporter().exportFolder(e);
  }
  async exportSubtreeFolder(e, i = {}) {
    return this.exporter().subtreeToFolder(e, i);
  }
  async promoteSubtreeToAsset(e, i = {}) {
    return this.exporter().promoteToAsset(e, i);
  }
  async exportObjectToGlbBlob(e) {
    return this.exporter().objectToGlbBlob(e);
  }
  async toBlob({ mimeType: e = "image/png" } = {}) {
    if (!this.traceScene || !this.engine) throw new Error("Scene or engine is not initialized");
    const i = this.traceScene.getBabylonScene(), r = this.engine;
    return new Promise((n, a) => {
      i.onAfterRenderObservable.addOnce(() => {
        const s = i.activeCamera;
        if (!s) {
          a(/* @__PURE__ */ new Error("No active camera"));
          return;
        }
        ye.captureScreenshot(r, s, e).then(n);
      }), i.render();
    });
  }
  getSceneRoot() {
    return this.traceScene?.getSceneRoot() ?? null;
  }
  getDocumentRoot() {
    return this.traceScene?.getDocumentRoot() ?? null;
  }
  async pushSceneData(e) {
    return this.traceScene ? await this.traceScene.pushSceneData(e) : null;
  }
  getSceneData() {
    return this.traceScene ? this.traceScene.getSceneDataList() : [];
  }
  connectedCallback() {
    if (this.engine || this.loaded) return;
    this.loaded = !0, this.setupCanvas();
    try {
      this.initializeEngine();
    } catch (r) {
      const n = r instanceof Error ? r : /* @__PURE__ */ new Error("WebGL is not supported");
      u.error(`[TraceViewer] Engine initialization failed: ${n.message}`), this._failReady(n), this.dispatchEvent(new CustomEvent("error", { detail: { error: n } }));
      return;
    }
    const e = this.loadScene(), i = this.traceScene;
    e.catch((r) => {
      if (i && this.traceScene !== i) return;
      const n = r instanceof Error ? r : new Error(String(r));
      u.error(`[TraceViewer] loadScene failed: ${n.message}`), this._failReady(n), this.dispatchEvent(new CustomEvent("error", { detail: { error: n } }));
    }), this._resizeHandler = () => this.onResize(), window.addEventListener("resize", this._resizeHandler), this.canvas.addEventListener("wheel", (r) => {
      Math.abs(r.deltaX) > 0 && r.preventDefault();
    }, { passive: !1 });
  }
  _failReady(e) {
    if (this._readyResolve) this._readyReject?.(e);
    else if (this._ready || !this._readyPromise) {
      const i = Promise.reject(e);
      i.catch(() => {
      }), this._readyPromise = i;
    }
    this._readyResolve = null, this._readyReject = null;
  }
  setupCanvas() {
    this.appendChild(this.canvas);
  }
  initializeEngine() {
    this.engine = new li(this.canvas, !0, void 0, !0), _r();
  }
  onResize() {
    this.engine?.resize();
  }
  async loadScene() {
    if (this.traceScene) return;
    const e = this.initializeConfig();
    this.traceScene = new Xt({
      engine: this.engine,
      canvas: this.canvas,
      config: e,
      traceViewer: this
    }), this._pendingEditModeClickToSelect !== null && this.traceScene.setEditModeClickToSelect(this._pendingEditModeClickToSelect);
    const i = this.traceScene.getBabylonScene();
    this.clickToSelect = new Si(i, this.traceScene);
    const r = this.traceScene, n = this;
    if (i.onPointerObservable.add((a, s) => {
      if (a.type === U.POINTERDOUBLETAP) {
        s.skipNextObservers = !0;
        for (const o of i.textures) if (o instanceof Ce && o._shouldBlockPointer) return;
        if (r.isPlayMode()) {
          const o = a.pickInfo;
          if (o?.hit && o.pickedMesh) {
            try {
              i.onPointerObservable.notifyObservers(new Qe(U.POINTERPICK, a.event, o), U.POINTERPICK);
            } finally {
              s.skipNextObservers = !0;
            }
            return;
          }
        }
        n.resetCamera();
      }
    }, -1, !0), this.selectionOutline = new vi(i, this.traceScene), this.xrManager = new zi(i, this.traceScene, this), this.xrManager.setClickToSelect(this.clickToSelect), this.xrManager.setLocalizers(this._localizers, this._selectedPlacementId), this._imageAlignmentConfig && this.xrManager.setImageAlignment(this._imageAlignmentConfig.imageUrl, this._imageAlignmentConfig.widthM), e.xr && this.xrManager.enableUI(), this.modelInfo = new Ni(this.traceScene), this._pendingEditModeClickToSelect !== null && (this.clickToSelect.enableClickToSelect(this._pendingEditModeClickToSelect, this._clickToSelectOptions), this._pendingEditModeClickToSelect && this.selectionOutline.enable(), this._pendingEditModeClickToSelect = null), e.src) {
      const a = new be("Initializing...", this);
      this.engine.loadingScreen = a, this.engine?.displayLoadingUI(), u.log("Loading scene from src"), await this.traceScene.loadFromURL(e.src, a, e.behaviors), this.engine?.hideLoadingUI();
    } else await this.traceScene.startScene();
    Y(this), this.traceScene.frameScene(), this.traceScene.startRendering(), u.log("Scene is ready, calling load event"), this._ready = !0, this._readyResolve && (this._readyResolve(), this._readyResolve = null), this.dispatchEvent(new Event("load")), this.engine?.resize();
  }
  initializeConfig() {
    const e = this.getAttribute("logger");
    e === "enabled" ? u.level = q.DEBUG : e === "log" ? u.level = q.LOG : e === "warn" ? u.level = q.WARN : e === "none" ? u.level = q.NONE : u.level = q.ERROR;
    let i;
    const r = this.getAttribute("behaviors");
    if (r) try {
      i = JSON.parse(r);
    } catch (n) {
      u.error(`[TraceViewer] Invalid behaviors attribute JSON: ${String(n)}`);
    }
    return {
      src: this.getAttribute("src"),
      color: this.getAttribute("backgroundcolor"),
      prewarm: Number(this.getAttribute("prewarmParticles")) || 0,
      cameraRadius: Number(this.getAttribute("cameraradius")) || 1,
      alpha: this.getAttribute("alpha") ? Number(this.getAttribute("alpha")) : null,
      blobGLB: this.getAttribute("blobGLB"),
      environmentImage: this.getAttribute("environment-image") ?? void 0,
      behaviors: i,
      groundShadow: this.getAttribute("ground-shadow") !== "false",
      groundHeight: parseFloat(this.getAttribute("ground-height") ?? "") || void 0,
      xr: this.hasAttribute("xr"),
      playMode: this.getAttribute("play-mode") !== "false"
    };
  }
  disconnectedCallback() {
    u.log("TraceViewer element removed, disposing scene"), this.dispose();
  }
  dispose() {
    if (this._failReady(jt()), !this.engine && !this.traceScene && !this._resizeHandler) {
      this.loaded = !0;
      return;
    }
    u.log("TraceViewer disposing resources"), this._ready = !1, this.disposeScene(), this.disposeEngine(), this._resizeHandler && (window.removeEventListener("resize", this._resizeHandler), this._resizeHandler = null), this.clickToSelect?.dispose(), this.clickToSelect = null, this.selectionOutline = null, this.xrManager?.dispose(), this.xrManager = null, this.modelInfo = null;
  }
  disposeScene() {
    this.traceScene && (this.traceScene.dispose(), this.traceScene = null);
  }
  disposeEngine() {
    this.engine && (this.engine.dispose(), this.engine = null);
  }
  enableClickToSelect(e, i) {
    i && (this._clickToSelectOptions = { ...i }), this.traceScene ? this.traceScene.setEditModeClickToSelect(e) : this._pendingEditModeClickToSelect = e, this.clickToSelect?.enableClickToSelect(e, this._clickToSelectOptions), e && this.selectionOutline?.enable();
  }
  peekNextPick(e, i) {
    return this.clickToSelect?.peekNextPick(e, i) ?? null;
  }
  notifyClickToSelectDrag() {
    this.clickToSelect?.notifyDragOccurred();
  }
  applyClickRouting(e) {
    this.clickToSelect?.enableClickToSelect(e);
  }
  selectObject(e) {
    this.traceScene?.select(e?.getPath() ?? null);
  }
  setOutlinedSelectionSet(e) {
    this.selectionOutline?.setOutlinedSet(e);
  }
  setPlayMode(e) {
    this.traceScene?.setPlayMode(e);
  }
  isPlayMode() {
    return this.traceScene?.isPlayMode() ?? !0;
  }
  setSafeAreaInsets(e) {
    this.traceScene?.setSafeAreaInsets(e);
  }
  get safeAreaInsets() {
    return this.traceScene?.safeAreaInsets ?? {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
  }
  setCollidersDebugVisible(e) {
    this.traceScene?.setCollidersDebugVisible(e);
  }
  set groundShadow(e) {
    this.traceScene?.setGroundShadowEnabled(e);
  }
  get groundShadow() {
    return this.traceScene?.groundShadowEnabled ?? !1;
  }
  set groundHeight(e) {
    this.traceScene?.setGroundHeight(e);
  }
  getModelInfo(e) {
    return this.modelInfo ? this.modelInfo.getModelInfo(e.getPath()) : null;
  }
  getSceneInfo() {
    return this.modelInfo ? this.modelInfo.getSceneInfo() : null;
  }
  get isXRSupported() {
    return this.xrManager?.isSupported ?? !1;
  }
  async checkXRSupport() {
    return this.xrManager?.checkSupport() ?? Promise.resolve(!1);
  }
  get xrState() {
    return this.xrManager?.state ?? y.NOT_SUPPORTED;
  }
  isXRActive() {
    return this.xrManager?.isActive ?? !1;
  }
  async enterXR() {
    if (!this.xrManager) throw new Error("XR manager not initialized");
    await this.xrManager.enterXR();
  }
  async exitXR() {
    this.xrManager && await this.xrManager.exitXR();
  }
  setImageAlignment(e, i) {
    this._imageAlignmentConfig = {
      imageUrl: e,
      widthM: i
    }, this.xrManager?.setImageAlignment(e, i);
  }
  setLocalizers(e, i) {
    const r = e === null ? null : Ee(e, i).selected;
    return this.xrManager?.setLocalizers(e, i), this._localizers = e === null ? null : structuredClone([...e]), this._selectedPlacementId = r?.id, r;
  }
  async selectLocalizer(e) {
    if (!this._localizers) throw new Error("No authored placements are configured.");
    Ee(this._localizers, e);
    const i = this.xrManager?.state === y.ACTIVE;
    i && await this.xrManager.exitXR(), this.setLocalizers(this._localizers, e), i && await this.xrManager.enterXR();
  }
  getSceneObject(e) {
    return this.traceScene ? e == null ? this.traceScene.getSceneRoot() : this.traceScene.resolveSceneObject(e) : null;
  }
};
customElements.get("trace-viewer") || customElements.define("trace-viewer", Sr);
var ac = Gt();
_i();
export {
  ls as ALL_3D_EXTENSIONS,
  ns as AUDIO_EXTENSIONS,
  wa as AiSession,
  Lr as AnchorOrientation,
  kn as Animation,
  Nn as AnimationSequence,
  zn as AnimationStateHandle,
  Vn as AudioClip,
  Ca as AudioSource,
  fa as AutoUI,
  xr as BEHAVIOR_SCHEMAS,
  vn as BLOCK_DEFS,
  Er as BUILTIN_PREFIX,
  ac as BUILT_IN_BEHAVIOR_COUNT,
  Jn as BehaviorGraph,
  qn as Bevel,
  da as Billboard,
  la as BoxCollider,
  Kn as CONTROLS_MESH_SUFFIX,
  ma as ContentSlot,
  os as DATA_EXTENSIONS,
  is as DECODED_IMAGE_EXTENSIONS,
  Vs as DEFAULT_ENVIRONMENT_IMAGE_URL,
  Ka as DROPPABLE_ASSET_EXTENSIONS,
  Ss as DragToMove,
  ps as Frame,
  Ia as GraphBuilder,
  qr as GraphOps,
  Qn as GraphValidationError,
  as as IMAGE_EXTENSIONS,
  fn as INTERVAL_MACRO,
  yn as INTERVAL_MACRO_DEF,
  un as INTERVAL_MACRO_OP,
  vs as Image,
  bs as ImageAnchor,
  ua as Keyframes,
  Pr as Layout,
  Ar as LayoutItem,
  on as MACRO_ID_KEY,
  Sn as MACRO_OP_PREFIX,
  mn as MACRO_PARAM_WIRED,
  hn as MACRO_ROLE_KEY,
  cs as MODEL_EXTENSIONS,
  Fa as MarkerSlot,
  _s as MeshBackground,
  ga as Model,
  ys as MorphStretch,
  pa as Moveable,
  Qa as NATIVE_IMAGE_EXTENSIONS,
  ia as PAGE_STATE_ENTER,
  jn as PAGE_STATE_EXIT,
  Mr as PRIMITIVE_MESH_PARAMS,
  Va as PROPERTY_SHEET_VERSION,
  Wn as Pages,
  za as ParticleBlendMode,
  ya as ParticleShapeType,
  Sa as ParticleSystem,
  La as ParticleTextureMode,
  Xa as Properties,
  xa as Provenance,
  Ra as RECORDING_TRACKS_PATH,
  Oa as RecordingInfo,
  cn as Renderer,
  Pa as RestRelativeBinding,
  ba as Rotatable,
  Ta as Rotate,
  Hs as RuntimeSelectionManager,
  rs as SCENE_EXTENSIONS,
  Gs as SCENE_ROOT_NAME,
  Ba as SCRIPT_API_TYPES,
  hs as SCRIPT_EXTENSIONS,
  Ja as SPLAT_EXTENSIONS,
  es as STREAMABLE_MIME_TYPES,
  An as SUBGRAPH_INDEX_KEY,
  jr as SUBGRAPH_MANIFEST_KEY,
  bn as SceneCreation,
  Kt as SceneExporter,
  _n as ScriptBehavior,
  aa as ScriptRegistry,
  ra as SphereCollider,
  dn as Synth,
  Wr as TOGGLE_ACTIVE_MACRO,
  Ur as TOGGLE_ACTIVE_MACRO_DEF,
  sn as TOGGLE_ACTIVE_MACRO_OP,
  xn as TOGGLE_ACTIVE_TARGET_PARAM,
  ln as TRACE_MACRO_KEY,
  Vr as TRACE_SUBGRAPH_KEY,
  _a as Tether,
  Ls as Text,
  Da as Timeline,
  Ks as TraceExport,
  Xt as TraceScene,
  Sr as TraceViewer,
  qs as UID_LENGTH,
  Xr as UNLISTED_BLOCK_DEFS,
  ye as Utility,
  ss as VIDEO_EXTENSIONS,
  Zn as Video,
  Aa as ViewAnchor,
  Fr as WrapMode,
  oo as alignAnchorToWorld,
  ao as alignPlacementToWorld,
  Jr as allMacros,
  ro as animateCameraPullback,
  eo as applyAnchorRotation,
  Jt as applyPlacementAnchorPose,
  ta as assertExecutableGraph,
  so as attachImageAnchor,
  Hr as boundPropertyName,
  Fn as clearClipNameCache,
  Or as createDefaultData,
  Cr as createPrimitiveWithMaterial,
  Ds as declareFontPacks,
  Ms as declaredFontFamilies,
  ws as declaredFontPack,
  fs as decodeGeoTiff,
  ea as dryRunHooks,
  Rs as ensureFontFamily,
  en as expandIntervalMacro,
  En as expandMacro,
  Bn as extractKeyframesFromAnimationGroup,
  _o as findGraphCycles,
  Ma as formatBehaviorSchema,
  to as frameAnchorCamera,
  no as framePlacementCamera,
  mo as generateClipGLB,
  go as generateClipsGLB,
  yr as getAddableBehaviorTypes,
  ts as getAssetCategory,
  br as getBehaviorConstructor,
  Ir as getBehaviorSchema,
  Kr as getBlockDef,
  Zr as getBlocksByCategory,
  Qr as getBlocksByDocGroup,
  kr as getBuiltInSrc,
  Dn as getClipNamesForSrc,
  In as getMacro,
  rn as getMacroByOp,
  wr as getPrimitiveType,
  $a as hasBoundComponent,
  Gn as hasPlayableClock,
  Cn as hasSubgraphDeclarations,
  Mn as hasSubgraphTags,
  Fs as hostedFontFailures,
  Yr as inlineSubgraphs,
  Rr as isBuiltInPrimitive,
  Za as isDecodedImageExtension,
  Hn as isPlayable,
  $r as isPropertyBinding,
  Ua as isPropertyTransition,
  Yn as isRuntimeToggleable,
  gs as isStreamableMimeType,
  Wa as isTimeTransition,
  Ys as isValidUid,
  Rn as loadAssetContainerFromSrc,
  Es as loadFace,
  Is as loadFontPack,
  zs as loadFontPackFromUrl,
  Tn as lowerBehaviorGraphData,
  nn as lowerMacros,
  qa as mimeTypeFromExtension,
  js as mintUid,
  Ha as numericTuple,
  Cs as onFontRegistryChange,
  Ns as onFontSubstitution,
  ks as onHostedFontFailure,
  Ga as parsePropertySheet,
  gn as raiseBehaviorGraphData,
  wn as raiseMacros,
  pn as recognizeIntervalMacros,
  an as recognizeMacros,
  tn as recollapseSubgraphs,
  Ea as recordingActivationBehavior,
  va as recordingActivationGraph,
  vo as referenceIdentityPath,
  Tr as registerBehavior,
  Bs as registerFace,
  Pn as registerMacro,
  Os as registeredRevision,
  co as resolveAnchorIsVertical,
  Dr as resolveAnchorPitchRadians,
  io as resolveLegacyHeuristicRotation,
  Ps as retryFontFamily,
  ka as setAutoUISwatchEditorCommit,
  us as toAcceptString,
  Ya as toDotExtensions,
  As as undeclareFontFamily,
  na as validateExecutableGraph
};

//# sourceMappingURL=traceviewer.js.map